import React, { useEffect, useState } from "react";
import { FaCircle } from "react-icons/fa";
import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import { Link, useLocation } from "react-router-dom";
import { FcPrint } from "react-icons/fc";
import { useSelector } from "react-redux";
import { url, nihCorpsAll } from "../configlink";

function ViewPaLink() {
  let loc = useLocation();
  // const token = localStorage.getItem("token");

  let [data, setData] = useState([]);
  let [tableDataDetails, setTableDataDetails] = useState([]);
  let [billingInfo, setBillingInfo] = useState([])

  let orderNum = loc.search.split("=")[1].split('&')[0];
  // console.log(orderNum);


  let [linkExpiredMessage, setLinkExpiredMessage] = useState(false)
  let [showCompletion, setShowCompletion] = useState(false)
  let [alreadyPaid, setAlreadyPaid] = useState(false)
  let [validity, setValidity] = useState('')

  let [prices, setPrices] = useState([])

  useEffect(() => {
      try {
        fetch(`${url}/api/orderForm/getPaLinkData?orderNumber=${orderNum}`,{
          method: "GET",
          credentials: 'include',
          // headers:{
          //   Authorization: `Bearer ${token}`,
          // }
        })
        .then(res => res.json())
        .then(data2 => {
          // console.log(data2); 
          if(data2.validDate){
            setValidity(data2.validDate)
          }  
          if(data2.result){
            let result = data2.result[0]
            // console.log(result);
            setData(result)

            fetch(`${url}/api/users/getUnitPricesPA?userId=${result.UserId}`, {
              method: "GET",
              credentials: "include",
              // headers: {
              //   Authorization: `Bearer ${token}`,
              // },
            })
            .then((res) => res.json())
            .then((data) => {
              // console.log('prices',data);
              if(data.length>0) {
                setPrices(data)
              }
              else{
                setPrices([])
              }
            })
            .catch((err) => {
              console.error(err);
            });


            if(result.OrderTypeId === 28){
              additionalPricesLV(result.TableData, result.Ordertype, result.ServiceType)
			}
			else if(result.OrderTypeId === 38){
				additionalPricesFLA(result)
			}
            else{
              additionalPrices(result.TableData)
            }

            //fsa
            if(result.OrderTypeId === 29 || result.OrderTypeId === 37 || result.OrderTypeId === 20) {
              // console.log("tdd", JSON.parse(result.OrderDetails));
              setTableDataDetails(JSON.parse(result.OrderDetails))
            }

            if(result.PrimerSynthesis === 1 || result.PrimerSynthesis === 2  ){
              primerPrices(result.PrimerSynthesis, result.PrimerSynthesisList)
            }

              fetch(`${url}/api/profile/getPersonalInfoPA?id=${result.UserId}`, {
                method: 'GET',
                credentials: 'include',
                // headers: {
                //   Authorization: `Bearer ${token}`,
                // },
              }
              )
              .then((res) => res.json())
              .then((data3) => {
                // console.log('userData', data3);
                setBillingInfo(data3.result)
              })
              .catch(err => {
                console.error(err);
              })                
          }
          else if(data2.message === 'Link expired'){
            setLinkExpiredMessage(true)
          }
          else if(data2.message === 'Already Paid'){
            setAlreadyPaid(true)
          }
          
          
        })
      }
      catch (err) {
        console.error(err);
      }
      
    }, [])

   


    // console.log('data', data);

    let [purifRow, setPurifRow] = useState(false)
    let [bacRow, setBacRow] = useState(false)
    let [cosmidRow, setCosmidRow] = useState(false)
    let [hgcRow, setHgcRow] = useState(false)
    let [hairpinRow, setHairpinRow] = useState(false)
    
    let [dcssPrepRow, setDcssPrepRow] = useState(false)
    let [agarPrepRow, setAgarPrepRow] = useState(false)
	
	let [stagingRow, setStagingRow] = useState(false)
    let [analysisBasicRow, setAnalysisBasicRow] = useState(false)
    let [analysisGenePrintRow, setAnalysisGenePrintRow] = useState(false)

    function additionalPrices(x){
      let tableData = x

      let purifData = []
      let bacData = []
      let cosmidData = []
      let dcssPrepData = []
      let agarPrepData = []
      let hgcCount = 0
      let hairpinCount = 0
      // console.log('td', tableData);
      for(let i = 0; i< tableData.length; i++) {
        if(tableData[i].dType === 'Unpurified PCR'){
          purifData.push(tableData[i].dName)
        }

        if(tableData[i].dType === 'BAC DNA'){
          bacData.push(tableData[i].dName)
        }

        if(tableData[i].dType === 'Cosmid'){
          cosmidData.push(tableData[i].dName)
        }

        if(tableData[i].hgc === 1){
          hgcCount++
        }

        if(tableData[i].hairpin === 1){
          hairpinCount++
        }


        if(tableData[i].dType && (tableData[i].dType.includes("Culture in") || tableData[i].dType.includes("Colony on"))){
          dcssPrepData.push(tableData[i].dName)

          if(tableData[i].dType === 'Colony on Agar Plate'){
            agarPrepData.push(tableData[i].dName)
          }
        }
      
      }

      let uniqueNames = new Set(purifData)
      let uniqueNamesCount = uniqueNames.size

      if(uniqueNamesCount > 0){
        setPurifRow({bool:true, qty: uniqueNamesCount})
      }

      let uniqueNames2 = new Set(bacData)
      let uniqueNamesCount2 = uniqueNames2.size

      if(uniqueNamesCount2 > 0){
        setBacRow({bool:true, qty: uniqueNamesCount2})
      }

      let uniqueNames3 = new Set(cosmidData)
      let uniqueNamesCount3 = uniqueNames3.size

      if(uniqueNamesCount3 > 0){
        setCosmidRow({bool:true, qty: uniqueNamesCount3})
      }
      
      if(hgcCount > 0){
        setHgcRow({bool:true, qty: hgcCount})
      }

      if(hairpinCount > 0){
        setHairpinRow({bool:true, qty: hairpinCount})
      }

      let dcssPrepUniqueNames = new Set(dcssPrepData)
      let dcssPrepCount = dcssPrepUniqueNames.size

      if(dcssPrepCount > 0){
        setDcssPrepRow({bool:true, qty: dcssPrepCount})
      }

      let agarPrepUniqueNames = new Set(agarPrepData)
      let agarPrepCount = agarPrepUniqueNames.size

      if(agarPrepCount > 0){
        setAgarPrepRow({bool:true, qty: agarPrepCount})
      }
      
    }

    function additionalPricesLV(x,y,z){
      let tableData = x

      let purifData = []
      let bacData = []
      let cosmidData = []
      let dcssPrepData = []
      let agarPrepData = []
      let hgcCount = 0
      let hairpinCount = 0
      // console.log('td2', tableData);
      for(let i = 0; i< tableData.length; i++) {
        if(tableData[i].dType === 'Unpurified PCR' && tableData[i].sampleType === 1){
          purifData.push(tableData[i].dName)
        }

        if(tableData[i].dType === 'BAC DNA' && tableData[i].sampleType === 1){
          bacData.push(tableData[i].dName)
        }

        if(tableData[i].dType === 'Cosmid' && tableData[i].sampleType === 1){
          cosmidData.push(tableData[i].dName)
        }

        if(tableData[i].hgc === 1 && tableData[i].sampleType === 1){
          hgcCount++
        }

        if(tableData[i].hairpin === 1 && tableData[i].sampleType === 1){
          hairpinCount++
        }

        //dcss
        if(y === 2 && tableData[i].dName !== 'CONTROL' && tableData[i].dName !== null && tableData[i].dName !== 'water' && tableData[i].dName !== 'empty' ){
          dcssPrepData.push(tableData[i].dName)

          if(z === 'Colony on Agar Plate'){
            agarPrepData.push(tableData[i].dName)
          }
        }
      }

      let uniqueNames = new Set(purifData)
      let uniqueNamesCount = uniqueNames.size

      if(uniqueNamesCount > 0){
        setPurifRow({bool:true, qty: uniqueNamesCount})
      }

      let uniqueNames2 = new Set(bacData)
      let uniqueNamesCount2 = uniqueNames2.size

      if(uniqueNamesCount2 > 0){
        setBacRow({bool:true, qty: uniqueNamesCount2})
      }

      let uniqueNames3 = new Set(cosmidData)
      let uniqueNamesCount3 = uniqueNames3.size

      if(uniqueNamesCount3 > 0){
        setCosmidRow({bool:true, qty: uniqueNamesCount3})
      }
      
      if(hgcCount > 0){
        setHgcRow({bool:true, qty: hgcCount})
      }

      if(hairpinCount > 0){
        setHairpinRow({bool:true, qty: hairpinCount})
      }

      let dcssPrepUniqueNames = new Set(dcssPrepData)
        let dcssPrepCount = dcssPrepUniqueNames.size

        if(dcssPrepCount > 0){
          setDcssPrepRow({bool:true, qty: dcssPrepCount})
        }

        let agarPrepUniqueNames = new Set(agarPrepData)
        let agarPrepCount = agarPrepUniqueNames.size

        if(agarPrepCount > 0){
          setAgarPrepRow({bool:true, qty: agarPrepCount})
        }

      
    }
	
	function additionalPricesFLA(x){
     
        let checkAdditionalFla = x.TableData
        // console.log('addFLA2', checkAdditionalFla);

        let stagingCount = 0
        let analysisBasicCount = 0
        let analysisGenePrintCount = 0
        
        for(let i=0; i<checkAdditionalFla.length; i++){
          let y = checkAdditionalFla[i]
          
          if(Number(y.hgc) === 1 && (y.dName !== 'CONTROL' && y.dName !== null && y.dName !== 'water' && y.dName !== 'empty')){
            stagingCount += 1
          }

          if(Number(y.hairpin) === 1){
            if(y.dType.includes('BASIC') && (y.dName !== 'CONTROL' && y.dName !== null && y.dName !== 'water' && y.dName !== 'empty')){
              analysisBasicCount += 1
            }
            else if(y.dType.includes('Gene') && (y.dName !== 'CONTROL' && y.dName !== null && y.dName !== 'water' && y.dName !== 'empty')){
              analysisGenePrintCount += 1
            }
          }

        }
        // console.log('staging count', stagingCount);
        if(stagingCount > 0){
          setStagingRow({bool:true, qty: stagingCount})
        }
        if(analysisBasicCount > 0) {
          setAnalysisBasicRow({bool:true, qty: analysisBasicCount})
        }
        if(analysisGenePrintCount > 0) {
          setAnalysisGenePrintRow({bool:true, qty: analysisGenePrintCount})
        }

    }
	
	
    let [primerRow, setPrimerRow] = useState(false)

    function primerPrices(x,y){
      let category
      if(x=== 1){
        category = 'PSND'
      }
      else if(x===2){
        category = 'PSPD'
      }

      let primerCount = y.length
      
      setPrimerRow({bool:true, label:category, count: primerCount})
      
    }
    

  let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  let days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  
  let [ccDetails, setCcDetails] = useState({
    paymentType: "cc",
    cardNumber: "",
    cardType: "",
    expMonth: "",
    expYear: "",
    ccv: "",
    cardHolder: "",
    zip: "",
    memo: "",
    po:"",
    paName: "",
    paPhone: "",
    paEmail: ""
  })

  function getThisDay(x) {
    // console.log(x);
    let thisDay = new Date(x + "T00:00:00"); 
    let year = thisDay.getUTCFullYear();
    let month = thisDay.getUTCMonth();
    let date = thisDay.getUTCDate().toString().padStart(2, "0");
    let day = thisDay.getUTCDay();
    return `${months[month]} ${date}, ${year} (${days[day]})`;
  }

  function getTimeDropbox(id){
    if(id === 1 || id === 2 || id === 4 || id === 12 || id === 3){
      return 'by 5:00pm EST'
    }
    // else if(id === 13 || id === 63 || id === 64 || id === 52 || id === 53 || id === 67 || id === 69){
    //   return 'by 3:30pm EST'
    // }
    else {
      return 'by 3:30pm EST'
    }
  }

	let nihCorporatesArray = nihCorpsAll

  function getThisDayDropbox(x,y,z) {
    let drId = y
    let time = getTimeDropbox(parseInt(drId))

    let thisDay = new Date(x + "T00:00:00"); 
    let year = thisDay.getFullYear();
    let month = thisDay.getMonth();
    let date = thisDay.getDate().toString().padStart(2, "0");
    let day = thisDay.getDay();
    
    if(nihCorporatesArray.includes(parseInt(z))){
      return `${months[month]} ${date}, ${year} (${days[day]}) ${time}`;
    }
    else {
      return `${months[month]} ${date}, ${year} (${days[day]})`;
    }
  }
   

  function getNextDay(x) {
    // console.log(x);
    let nextDay = new Date(x +  "T00:00:00");
    nextDay.setDate(nextDay.getDate() + 1);
    let year = nextDay.getFullYear();
    let month = nextDay.getMonth();
    let date = nextDay.getDate().toString().padStart(2, "0");
    let day = nextDay.getDay();
    if(day === 6){
      return `${months[month]} ${(parseInt(date)+2).toString().padStart(2, "0")}, ${year} ( Mon )  by 7:00pm CST`;
    }
    else{
      return `${months[month]} ${date}, ${year} ( ${days[day]} )  by 1:00pm CST`;
    }
  }


  // let prices = useSelector((state)=> state.user.prices)

  function getPrice(x,y){
    // console.log(x,y);
    
    let CategoryName
    if(x.includes('Single Pass')){
      CategoryName = 'Single Pass Primer Extension'
    }
    else if(x==='General'){
      CategoryName = x
    }
    else if(x.includes('Direct Colony')){
      CategoryName = 'Direct Colony Sequencing Service'
    }
    else if(x.includes('Large Volume')){
      CategoryName = 'Large Volume (96-well Plate)'
    }
  
    let Item 
    if(y==='Premium Service'){
      Item = y
    }
    else if(y==='Standard Service'){
      Item = y
    }
    else if(y==='LCO(Low Cost Option)'){
      Item = y
    }
    else if(y==='Load and Go service with clean up'){
      Item = 'LoadGo-CleanUp'
    }
    else if(y==='Load and Go service without clean up'){
      Item = 'LoadGo-No-CleanUp'
    }
    else if(y==='PCRT'){
      Item = y
    }
    else if(y==='PSND'){
      Item = y
    }
    else if(y==='PSPD'){
      Item = y
    }
    else if(y==='DCSS'){
      Item = y
    }
    else if(y==='Premium Service-FP48'){
      Item = y
    }
    else if(y==='Premium Service-FP96'){
      Item = y
    }
    else if(y==='Standard Service-FP48'){
      Item = y
    }
    else if(y==='Standard Service-FP96'){
      Item = y
    }
    else if(y==='LCO(Low Cost Option)-FP96'){
      Item = 'LCO-FP96'
    }
    else if(y==='LCO(Low Cost Option)-FP48'){
      Item = 'LCO-FP48'
    }
    else if(y==='Load and Go service with clean up-FP48'){
      Item = 'LoadGo-CleanUp-FP48'
    }
    else if(y==='Load and Go service with clean up-FP96'){
      Item = 'LoadGo-CleanUp-FP96'
    }
    else if(y==='Load and Go service without clean up-FP48'){
      Item = 'LoadGo-No-CleanUp-FP48'
    }
    else if(y==='Load and Go service without clean up-FP96'){
      Item = 'LoadGo-No-CleanUp-FP96'
    }
    else if(y==="HGC"){
      Item = y
    }
    else if(y==="HP"){
      Item = y
    }
    else if(y==="SDS"){
      Item = y
    }
    else if(y==="Consensus"){
      Item = y
    }

    if(prices.length > 0){
      let [filter] = prices.filter(a => a.CategoryName === CategoryName && a.Item === Item)
      
      // console.log(filter);
      let convertToNumberPrice = parseFloat(filter.Price)
      if (Number(convertToNumberPrice) === convertToNumberPrice && convertToNumberPrice % 1 === 0) {
        return convertToNumberPrice.toFixed(0); 
      } else {
          return convertToNumberPrice.toFixed(2);
      }
    }
    else{
      return 0
    }
  
  }

  let flaPlatePrice = 40
  let sampleStagingPrice = 3
  let basicPeak = 2
  let genePrint = 5
  
  
  const fsa_ssPrice = 0.35
  const fsa_dsPrice = 0.45
	const fsa_psndPrice = 40  // 50
	const fsa_pspdPrice = 50  // 60

  function getFsaCount(x){
    let estimateData = {}
    let pspdQty = 0
    let psndQty = 0

    for(let i=0; i< tableDataDetails.length; i++){
      if(!estimateData[tableDataDetails[i].serviceOption]){
        estimateData[tableDataDetails[i].serviceOption] = 0
      }
      estimateData[tableDataDetails[i].serviceOption] += parseInt(tableDataDetails[i].length)
  
      if(tableDataDetails[i].sequencingPrimer === 'Synthesis Required'){
        if(tableDataDetails[i].serviceOption.includes("Single")){
          psndQty += Math.ceil((parseInt(tableDataDetails[i].length)/600))
        }
        else {
          psndQty += Math.ceil((parseInt(tableDataDetails[i].length)/600))*2
        }
      }
      else if(tableDataDetails[i].sequencingPrimer === 'Design & Synthesis Required'){
        if(tableDataDetails[i].serviceOption.includes("Single")){
          pspdQty += Math.ceil((parseInt(tableDataDetails[i].length)/600))
        }
        else {
          pspdQty += Math.ceil((parseInt(tableDataDetails[i].length)/600))*2
        }
      }
    }
    // console.log("ED", estimateData);

    if(x.includes("Single")){
        return estimateData["Single Stranded Coverage"] ? estimateData["Single Stranded Coverage"] : 0
      }
    
    if(x.includes("Double")){
      return estimateData["Double Stranded Coverage"] ? estimateData["Double Stranded Coverage"] : 0
    }

    if(x.includes("PSND")){
      return psndQty
    }

    if(x.includes("PSPD")){
      return pspdQty
    }
    
  }




  let pr11 = 120
  let pr12 = 130
  let pr13 = 130
  let pr14 = 150

  let pr21 = 120
  let pr22 = 130
  let pr23 = 120
  let pr24 = 130
  let pr25 = 250
  let pr25_2 = 130
  let pr26 = 350
  let pr26_2 = 150

  let pr31 = 145
  let pr32 = 155
  let pr33 = 275
  let pr34 = 155
  let pr35 = 400
  let pr36 = 185

  function getNgsCount(x){

    let count11 = 0
    let count12 = 0
    let count13 = 0
    let count14 = 0
    
    let count21= 0
    let count22= 0
    let count23= 0
    let count24= 0
    let count25= 0
    let count25_2= 0
    let count26= 0
    let count26_2= 0

    let count31= 0
    let count32= 0
    let count33= 0
    let count34= 0
    let count35= 0
    let count36= 0

    for(let i=0; i< tableDataDetails.length; i++){
      if(tableDataDetails[i].sampleType.value === 1){ 
        if(tableDataDetails[i].targetType.value === 1){
          if(tableDataDetails[i].dataAnalysis.value === 1){
            count11++
          }
          else if(tableDataDetails[i].dataAnalysis.value === 2){
            count12++
          }
          else if(tableDataDetails[i].dataAnalysis.value === 3){
            count13++
          }
          else if(tableDataDetails[i].dataAnalysis.value === 4){
            count14++
          }
        }
      }
      else if(tableDataDetails[i].sampleType.value === 2){
        if(tableDataDetails[i].targetType.value === 11){
          if(tableDataDetails[i].dataAnalysis.value === 1){
            count21++
          }
          else if(tableDataDetails[i].dataAnalysis.value === 2){
            count22++
          }
        }
        else if(tableDataDetails[i].targetType.value === 12){
          if(tableDataDetails[i].dataAnalysis.value === 1){
            count23++
          }
          else if(tableDataDetails[i].dataAnalysis.value === 2){
            count24++
          }
        }
        else if(tableDataDetails[i].targetType.value === 13){
          if(tableDataDetails[i].dataAnalysis.value === 1){
            count25++
          }
          else if(tableDataDetails[i].dataAnalysis.value === 2){
            count25_2++
          }
        }
        else if(tableDataDetails[i].targetType.value === 14){
          if(tableDataDetails[i].dataAnalysis.value === 1){
            count26++
          }
          else if(tableDataDetails[i].dataAnalysis.value === 2){
            count26_2++
          }
        }
      }
      else if(tableDataDetails[i].sampleType.value === 3){
        if(tableDataDetails[i].targetType.value === 21){
          if(tableDataDetails[i].dataAnalysis.value === 1){
            count31++
          }
          else if(tableDataDetails[i].dataAnalysis.value === 2){
            count32++
          }
        }
        else if(tableDataDetails[i].targetType.value === 22){
          if(tableDataDetails[i].dataAnalysis.value === 1){
            count33++
          }
          else if(tableDataDetails[i].dataAnalysis.value === 2){
            count34++
          }
        }
        else if(tableDataDetails[i].targetType.value === 23){
          if(tableDataDetails[i].dataAnalysis.value === 1){
            count35++
          }
          else if(tableDataDetails[i].dataAnalysis.value === 2){
            count36++
          }
        }
      }
    }

    if(x===11){
      return count11
    }
    else if(x===12){
      return count12
    }
    else if(x===13){
      return count13
    }
    else if(x===14){
      return count14
    }
    else if(x===21){
      return count21
    }
    else if(x===22){
      return count22
    }
    else if(x===23){
      return count23
    }
    else if(x===24){
      return count24
    }
    else if(x===25){
      return count25
    }
    else if(x===25_2){
      return count25_2
    }
    else if(x===26){
      return count26
    }
    else if(x===26_2){
      return count26_2
    }
    else if(x===31){
      return count31
    }
    else if(x===32){
      return count32
    }
    else if(x===33){
      return count33
    }
    else if(x===34){
      return count34
    }
    else if(x===35){
      return count35
    }
    else if(x===36){
      return count36
    }
  }
  

// const wps_amt11 = 10
// const wps_amt12 = 10
// const wps_amt21 = 10
// const wps_amt22 = 10
	
	const wps_standard = prices.find(x => x.Item === 'wps_standard') ? prices.find(x => x.Item === 'wps_standard').Price : 12
	const wps_large = prices.find(x => x.Item === 'wps_large') ? prices.find(x => x.Item === 'wps_large').Price : 24
	const wps_veryLarge = prices.find(x => x.Item === 'wps_veryLarge') ? prices.find(x => x.Item === 'wps_veryLarge').Price : 48
	const wps_culture = prices.find(x => x.Item === 'wps_culture') ? prices.find(x => x.Item === 'wps_culture').Price : 2.5
	
	function getWpsCount(x){
	
	let count11 = 0
	let count12 = 0
	let count13 = 0
	let count21 = 0
	let count22 = 0
	let count23 = 0
	let count31 = 0
	let count32 = 0
	let count33 = 0
	
	let tData = data.TableData
	// console.log(tData);    

	for(let i=0; i< tData.length; i++){
		let pcrSize2 = Number(tData[i].pcrSize)/1000 < 1 ? Number(tData[i].pcrSize) : Number(tData[i].pcrSize)/1000
		
		if(tData[i].dType.toLowerCase().includes('plasmid')){ 
			if(pcrSize2 <= 25){
				count11++
			}
			else if(pcrSize2 > 25 && pcrSize2 <= 125){
				count21++
			}
			else if(pcrSize2> 125 && pcrSize2 <= 200){
				count31++
			}
		}
		else if(tData[i].dType.toLowerCase().includes('amplicon') || tData[i].dType.toLowerCase().includes('fragment')){ 
			if(pcrSize2<= 25){
				count12++
			}
			else if(pcrSize2 > 25 && pcrSize2 <= 125){
				count22++
			}
			else if(pcrSize2 > 125 && pcrSize2 <= 200){
				count32++
			}
		}
		else if(tData[i].dType.toLowerCase().includes('culture')){ 
			if(pcrSize2<= 25){
				count13++
			}
			else if(pcrSize2 > 25 && pcrSize2 <= 125){
				count23++
			}
			else if(pcrSize2 > 125 && pcrSize2 <= 200){
				count33++
			}
		}
	}
	
	if(x===11){
		return count11
	}
	else if(x===12){
		return count12
	}
	else if(x===13){
		return count13
	}
	else if(x===21){
		return count21
	}
	else if(x===22){
		return count22
	}
	else if(x===23){
		return count23
	}
	else if(x===31){
		return count31
	}
	else if(x===32){
		return count32
	}
	else if(x===33){
		return count33
	}

	}
 

  const genomic_amt1 = 15
  const genomic_amt2 = 35
  const genomic_amt3 = 45
	const genomic_amt4 = 40  // 50
	const genomic_amt5 = 50  // 60
  const genomic_amt6 = 30
  const genomic_amt7 = 100

  function getGenomicCount(x){

    let count1 = tableDataDetails ? tableDataDetails.length : 0
    let count2 = 0
    let count3 = 0
    let count4 = 0
    let count5 = 0
    let count6 = 0
    let count7 = 0

    for(let i=0; i< tableDataDetails.length; i++){
      let ampliconIndex = tableDataDetails[i].ampliconData
      // console.log(ampliconIndex);

      if(tableDataDetails[i].purification === "Yes"){
        count6++
      }

      if(tableDataDetails[i].consensus === "Yes"){
        count7++
      }
      
      for(let j=0; j<ampliconIndex.length; j++){
        count2++
        count3++

        if(ampliconIndex[j].primerDesign === 'Synthesis Required'){
          count4 += 2
        }
        else if(ampliconIndex[j].primerDesign === 'Design & Synthesis Required'){
          count5 += 2
        }
      }
    }

    if(x===1){
      return count1
    }
    else if(x===2){
      return count2
    }
    else if(x===3){
      return count3
    }
    else if(x===4){
      return count4
    }
    else if(x===5){
      return count5
    }
    else if(x===6){
      return count6
    }
    else if(x===7){
      return count7
    }
  }


  let orderDetailData = [
    data.OrderTypeId === 25 ? {
      header: 'Turnaround Time',
      // value: data.iTurnAroundTime === 3? `Standard Order Service - ${getNextDay(data.OrderDateTime.split('T')[0])}`: data.iTurnAroundTime === 4? `Rush Order Service - ${getThisDay(data.OrderDateTime.split('T')[0])}`: data.iTurnAroundTime === 1? `Next Day Service - ${getNextDay(data.OrderDateTime.split('T')[0])}`: data.iTurnAroundTime === 2? `Same Day Service - ${getThisDay(data.OrderDateTime.split('T')[0])}`:''
      value: data.sTurnAroundTime
    } :
    {
      header: 'empty',
      value:'empty'
    }
    ,
    (data.OrderTypeId === 25 || data.OrderTypeId === 28) ? 
    {
      header: 'Service Option',
      value: data.ServiceType?data.ServiceType:""
    }
    :
    {
      header: 'empty',
      value:'empty'
    }
    ,
    data.OrderTypeId === 25 ? 
    {
      header: 'Consensus',
      value: data.OrderTypeId===25?(data.Consensus===1?'Yes':'No'):'No'
    } :
    {
      header: 'empty',
      value:'empty'
    }
    ,
    {
      header: 'Dropbox Information',
      value: data.DropBoxId ? `${data.DropBoxLocation} - ${getThisDayDropbox(data.DropBoxDate.split('T')[0], data.DropBoxId, billingInfo.CorporateId)}`: 'Ship Sample'
    },
  ]


  function getTotalPrice(){
    let totalPrice = 0

    let price1 = document.getElementById('subTotal1')
    let price2 = document.getElementById('subTotal2')
    let price3 = document.getElementById('subTotal3')
    let price4 = document.getElementById('subTotal4')
    let price5 = document.getElementById('subTotal5')
    let price6 = document.getElementById('subTotal6')
    let price7 = document.getElementById('subTotal7')
    let price8 = document.getElementById('subTotal8')
    let price9 = document.getElementById('subTotal9')
    let price10 = document.getElementById('subTotal10')
    let price11 = document.getElementById('subTotal11')
    let price12 = document.getElementById('subTotal12')
    let price13 = document.getElementById('subTotal13')
    let price14 = document.getElementById('subTotal14')
    let price15 = document.getElementById('subTotal15')
    let price16 = document.getElementById('subTotal16')
    let price17 = document.getElementById('subTotal17')
    let price18 = document.getElementById('subTotal18')

    if(price1){
      totalPrice += parseFloat(price1.innerHTML.split('$')[1])
    }
    if(price2){
      totalPrice += parseFloat(price2.innerHTML.split('$')[1])
    }
    if(price3){
      totalPrice += parseFloat(price3.innerHTML.split('$')[1])
    }
    if(price4){
      totalPrice += parseFloat(price4.innerHTML.split('$')[1])
    }
    if(price5){
      totalPrice += parseFloat(price5.innerHTML.split('$')[1])
    }
    if(price6){
      totalPrice += parseFloat(price6.innerHTML.split('$')[1])
    }
    if(price7){
      totalPrice += parseFloat(price7.innerHTML.split('$')[1])
    }
    if(price8){
      totalPrice += parseFloat(price8.innerHTML.split('$')[1])
    }
    if(price9){
      totalPrice += parseFloat(price9.innerHTML.split('$')[1])
    }
    if(price10){
      totalPrice += parseFloat(price10.innerHTML.split('$')[1])
    }
    if(price11){
      totalPrice += parseFloat(price11.innerHTML.split('$')[1])
    }
    if(price12){
      totalPrice += parseFloat(price12.innerHTML.split('$')[1])
    }
    if(price13){
      totalPrice += parseFloat(price13.innerHTML.split('$')[1])
    }
    if(price14){
      totalPrice += parseFloat(price14.innerHTML.split('$')[1])
    }
    if(price15){
      totalPrice += parseFloat(price15.innerHTML.split('$')[1])
    }
    if(price16){
      totalPrice += parseFloat(price16.innerHTML.split('$')[1])
    }

    // console.log("total",totalPrice);
    

    return `$${totalPrice.toFixed(2)}`
  }

	function getDiscountPrice(x, type2){
		// console.log(x, type2);
	
		let totPrice = getTotalPrice()
	
		if(type2 === 'Sanger_Validation'){
			let discountCalc = Number(data.TableData.length)
			return `-$${discountCalc.toFixed(2)}`
		}
		else if(Number(type2) === 1){
			let discountCalc = Number(x)
			return `-$${discountCalc.toFixed(2)}`
		}
		else if(Number(type2) === 2){
			let discountCalc = Number(totPrice.split('$')[1])*Number(x)/100
			let disUpto2 = Number(data.discount_upto)
		
			if(disUpto2 > 0){ 
				return `-$${(Math.min(discountCalc, disUpto2)).toFixed(2)}`
			}
			else {
				return `-$${discountCalc.toFixed(2)}`
			}
		}
		else {
			let discountCalc = Number(x)
		
			return `-$${discountCalc.toFixed(2)}`
		}
		
	}

	function getFinalPrice(){
		let totalFinalPrice = 0
	
		let price1 = document.getElementById('subTotal101')
		let price2 = document.getElementById('subTotal102')
		
	
		if(price1){
			totalFinalPrice += parseFloat(price1.innerHTML.split('$')[1])
		}
		if(price2){
			totalFinalPrice -= parseFloat(price2.innerHTML.split('$')[1])
		}
	
		// console.log("totalFinal",totalFinalPrice);
		
	
		return `$${totalFinalPrice.toFixed(2)}`
	}

  const SppeTemplate = () => {
    const samplePropertiesToShow = [
      "id",
      "dName",
      "dConc",
      "dType",
      "pcrSize",
      "pName",
      "pConc",
      "primerBank",
      "alt",
    ];
    return (
      <table className='border-1  w-full text-[12px]'>
            <thead>
              <tr className=''>
                <th
                  colSpan={5}
                  className='border-[1px] text-black font-normal text-center'
                >
                  Template
                </th>
                <th
                  colSpan={5}
                  className='border-[1px] text-black font-normal text-center'
                >
                  Primer
                </th>              
              </tr>
              <tr>
                <th className='border-[1px] text-black text-center font-normal min-w-[30px] h-[40px]'>
                  #
                </th>
                <th className='border-[1px] text-black text-center font-normal min-w-[200px] h-[40px]'>
                  DNA Name
                </th>
                <th className='border-[1px] text-black text-center font-normal min-w-[70px] h-[40px]'>
                  Conc. <br /> (ng/ul)
                </th>
                <th className='border-[1px] text-black text-center font-normal min-w-[100px] h-[40px]'>
                  DNA Type
                </th>
                <th className='border-[1px] text-black text-center font-normal min-w-[50px] h-[40px]'>
                  Insert Size
                </th>
                {/* <th className='border-[1px] text-black text-center font-normal min-w-[100px]'>
                 Universal Primers
                </th> */}
                <th className='border-[1px] text-black text-center font-normal min-w-[200px] h-[40px]'>
                 Primer Name
                </th>
                <th className='border-[1px] text-black text-center font-normal min-w-[70px] h-[40px]'>
                  Conc. <br /> (pmol/ul)
                </th>
                <th className='border-[1px] text-black text-center font-normal min-w-[60px] h-[40px]'>
                 Banked <br /> Previously
                </th>
                <th className='border-[1px] text-black text-center font-normal min-w-[80px] h-[40px]'>
                 Alternative Protocols       
                </th>
              </tr>
            </thead>
            <tbody>
             {
              data.TableData && data.TableData.map((item, index) => (
                <tr key={index} >
                  {samplePropertiesToShow.map((property) => (
                    <td key={property} className='p-0 text-[11px]'>
                      {property === "dName" ? (
                        <div className='flex items-center h-[28px] px-4 border-[1px] border w-full'>
                          {item[property]}
                        </div>
                      ) : 
                      property === "pName" ? (
                        <div
                          className={`flex items-center h-[28px]  px-4 border-[1px] w-full  `}
                        >
                          {item[property]}
                        </div>
                      ) : property === "pConc" ? (
                        <div className='flex items-center justify-center h-[28px] text-center px-4 border-[1px]  w-full '>
                          {item[property]}
                        </div>
                      ) : property === "pcrSize" ? (
                        <div className='flex items-center justify-center h-[28px] text-center px-4 border-[1px]  w-full '>
                          {item[property]}
                        </div>
                      ) : property === "dType" ? (
                        <div className='flex items-center justify-center h-[28px] text-center  px-4 border-[1px]  w-full '>
                          {item[property]}
                        </div>
                      ) : property === "alt" ? (
                        <div className='flex items-center justify-center h-[28px] text-center px-4 border-[1px]  w-full '>
                          {item.hgc === 1 ? 'High GC': item.hairpin === 1 ? 'Hairpin' : ''}
                        </div>
                      ) : property === "dConc" ? (
                        <div className='flex items-center justify-center h-[28px] text-center px-4 border-[1px]  w-full '>
                          {item[property]}
                        </div>
                      ) : property === "id" ? (
                        <div className='flex items-center justify-center text-center h-[28px] px-4 border-[1px]  w-full '>
                          {index+1}
                        </div>
                      ) : property === "primerBank" ? (
                        <div className='flex items-center justify-center h-[28px]  border-[1px] '>
                          {item[property] === 1 ? (
                            <div>
                              Yes
                            </div>
                          ) : (
                            <div>
                              No
                            </div>
                          )}
                        </div>
                      ) : null}
                    </td>
                  ))}
                </tr>
              ))
             }
            </tbody>
          </table>
    )
  }

  const DcssTemplate = () => {
    const samplePropertiesToShow = [
      "id",
      "dName",
      "dType",
      "pName",
      "pConc",
      "primerBank",
    ];
    return (
      <table className='border-1  w-full text-[12px]'>
            <thead>
              <tr className=''>
                <th
                  colSpan={3}
                  className='border-[1px] text-black font-normal text-center'
                >
                  Template
                </th>
                <th
                  colSpan={3}
                  className='border-[1px] text-black font-normal text-center'
                >
                  Primer
                </th>              
              </tr>
              <tr>
                <th className='border-[1px] text-black text-center font-normal min-w-[30px] h-[40px]'>
                  #
                </th>
                <th className='border-[1px] text-black text-center font-normal min-w-[200px] h-[40px]'>
                  DNA Name
                </th>
                <th className='border-[1px] text-black text-center font-normal min-w-[100px] h-[40px]'>
                  Colony Type
                </th>
                <th className='border-[1px] text-black text-center font-normal min-w-[200px] h-[40px]'>
                 Primer Name
                </th>
                <th className='border-[1px] text-black text-center font-normal min-w-[70px] h-[40px]'>
                  Conc. <br /> (pmol/ul)
                </th>
                <th className='border-[1px] text-black text-center font-normal min-w-[60px] h-[40px]'>
                 Banked <br /> Previously
                </th>
              </tr>
            </thead>
            <tbody>
             {
              data.TableData && data.TableData.map((item, index) => (
                <tr key={index} >
                  {samplePropertiesToShow.map((property) => (
                    <td key={property} className='p-0 text-[11px]'>
                      {property === "dName" ? (
                        <div className='flex items-center h-[28px] px-4 border-[1px] border w-full'>
                          {item[property]}
                        </div>
                      ) : 
                      property === "pName" ? (
                        <div
                          className={`flex items-center h-[28px]  px-4 border-[1px] w-full  `}
                        >
                          {item[property]}
                        </div>
                      ) : property === "pConc" ? (
                        <div className='flex items-center justify-center h-[28px] text-center px-4 border-[1px]  w-full '>
                          {item[property]}
                        </div>
                      ) :  property === "dType" ? (
                        <div className='flex items-center justify-center h-[28px] text-center  px-4 border-[1px]  w-full '>
                          {item[property]}
                        </div>
                      ) :  property === "id" ? (
                        <div className='flex items-center justify-center text-center h-[28px] px-4 border-[1px]  w-full '>
                          {index+1}
                        </div>
                      ) : property === "primerBank" ? (
                        <div className='flex items-center justify-center h-[28px]  border-[1px] '>
                          {item[property] === 1 ? (
                            <div>
                              Yes
                            </div>
                          ) : (
                            <div>
                              No
                            </div>
                          )}
                        </div>
                      ) : null}
                    </td>
                  ))}
                </tr>
              ))
             }
            </tbody>
          </table>
    )
  }

  const HtpTemplate = () => {
    // let transformedTable = []
    // let transformedTable2 = []

    // for (let i = 0; i < data.TableData.length; i += 12) {
    //     let group = data.TableData.slice(i, i + 12);
    //     transformedTable.push(group);
    //   }
      
    //   for(let j=0; j<transformedTable.length; j += 8){
    //     let group2 = transformedTable.slice(j,j + 8)
    //     transformedTable2.push(group2);
    // }

    let transformedTable2 = [];
    let groupSize = 96;
    let rowCount = 8;

    for (let g = 0; g < data.TableData.length; g += groupSize) {
      let groupData = data.TableData.slice(g, g + groupSize);
      
      let verticalTable = Array.from({ length: rowCount }, () => []);
      for (let i = 0; i < groupData.length; i++) {
        verticalTable[i % rowCount].push(groupData[i]);
      }

      transformedTable2.push(verticalTable);
    }

    // console.log("TT",transformedTable2);

    let col1 = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H']

    return (
    <div className='flex flex-col gap-[30px]'>

        {
            data.TableData && transformedTable2.map((item,index) => (
                <div key={item.id} className='w-full overflow-x-auto'>
                    <table className='border-1 w-full'>
                        <thead>
                            <tr>
                                <th colSpan={13} className='p-2 border-[1px] text-[13px] text-black text-left  bg-gray-100'>
                                    Plate #{index+1} &nbsp; &nbsp; &nbsp; &nbsp; Plate Name: {item[0][0].plateName}
                                </th>
                            </tr>
                            <tr>
                                <th className='border-[1px] text-[15px] text-black h-[28px] text-center  bg-gray-100 w-[25px]'>
                                
                                </th>

                                {Array.from({length:12}).map((x,index) => (
                                    <th 
                                    key={index} 
                                    className='border-[1px] text-[12px] text-black h-[28px] text-center  bg-gray-100 flex-1'
                                    >
                                        {index+1}
                                    </th>
                                ))}
                                            
                            </tr>
                        </thead>
                    <tbody>
                        {
                            item.map((item2,k) => (
                                  <tr key={item2.id}>
                                       <td className='flex items-center text-[12px] h-[40px] px-4 border-[1px]  bg-gray-100 font-semibold'>{col1[k]}</td>
                                      {item2.map((x,j) => (
                                          k===7 && j===11?
                                          <td key={j} className='p-0'>
                                              <div className='relative flex h-[40px] border-[1px] border-gray-300'>
                                                  <p className='text-[10px] absolute top-[5px] left-[5px]'>CONTROL</p>
                                              </div>                            
                                          </td>
                                          :
                                          <td key={j} className='p-0'>
                                              <div className='flex flex-col justify-between h-[40px] border-[1px] border-gray-300 min-w-[80px] p-[2px]'>
                                                  <p className='text-[10px] text-blue-600 pr-2'>{x.dName}</p>
                                                  <p className='text-[10px] text-right text-purple-700 pl-2'>{x.pName===""?x.library:x.pName}</p>
                                              </div>                            
                                          </td>
                                      ))}                          
                                  </tr>
                            ))
                        }
                    </tbody>
                    </table>
                </div>
            ))
        }
    
    </div>        
      
    )
  }
	
	
	const FlaTemplate = () => {

	let transformedTable2 = [];
	let groupSize = 96;
	let rowCount = 8;

	for (let g = 0; g < data.TableData.length; g += groupSize) {
		let groupData = data.TableData.slice(g, g + groupSize);
		
		let verticalTable = Array.from({ length: rowCount }, () => []);
		for (let i = 0; i < groupData.length; i++) {
			verticalTable[i % rowCount].push(groupData[i]);
		}
	
		transformedTable2.push(verticalTable);
	}

	// console.log("TT",transformedTable2);

	let col1 = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H']

	return (
	<div className='flex flex-col gap-[30px]'>
		{
			data.TableData && transformedTable2.map((item,index) => (
				<div key={item.id} className='w-full overflow-x-auto'>
					<table className='border-1 w-full'>
						<thead>
							<tr>
								<th colSpan={13} className='p-2 border-[1px] text-[13px] text-black text-left  bg-gray-100'>
									Plate #{index+1} &nbsp; &nbsp; &nbsp; &nbsp; Plate Name: {item[0][0].plateName}
									&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Staging: {item[0][0].hgc === 1 ? 'Yes': 'No'}
									&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Analysis: {item[0][0].hairpin === 1 ? item[0][0].dType : 'No'}  
								</th>
							</tr>
							<tr>
								<th className='border-[1px] text-[15px] text-black h-[28px] text-center  bg-gray-100 w-[25px]'>
								
								</th>

								{Array.from({length:12}).map((x,index) => (
									<th 
										key={index} 
										className='border-[1px] text-[12px] text-black h-[28px] text-center  bg-gray-100 flex-1'
									>
										{index+1}
									</th>
								))}
							
							</tr>
						</thead>
					<tbody>
						{
							item.map((item2,k) => (
								<tr key={item2.id}>
									<td className='flex items-center text-[12px] h-[40px] px-4 border-[1px]  bg-gray-100 font-semibold'>{col1[k]}</td>
									{item2.map((x,j) => (
										<td key={j} className='p-0'>
											<div className='flex flex-col justify-between h-[40px] border-[1px] border-gray-300 min-w-[80px] p-[2px]'>
												<p className='text-[10px] text-blue-600 pr-2'>{x.dName}</p>
												<p className='text-[10px] text-right text-purple-700 pl-2'>{x.pName===""?x.library:x.pName}</p>
											</div>                            
										</td>
									))}                          
								</tr>
							))
						}
					</tbody>
					</table>
				</div>
			))
		}
	
	</div>        
	
	)
	}
	
	
  const FsaTemplate = () => {
    const samplePropertiesToShow = [
      "id",
      "templateName",
      "serviceOption",
      "sequencingPrimer",
      "length",
      "reference",
      "comments"
    ];

    return (
      <table className='border-1 w-full text-[12px]'>
        <thead>
            <tr>
                <th className='border-[1px] text-black text-center font-normal h-[40px] min-w-[30px] '>
                  #
                </th>
                <th className='border-[1px] text-black text-center font-normal h-[40px] min-w-[250px]'>
                  Template Name
                </th>
                <th className='border-[1px] text-black text-center font-normal h-[40px] min-w-[220px]'>
                  Service Option
                </th>
                <th className='border-[1px] text-black text-center font-normal h-[40px] min-w-[150px]'>
                 Sequencing Primer
                </th>               
                <th className='border-[1px] text-black text-center font-normal h-[40px] min-w-[120px]'>
                  {`Expected Length (>2kb)`}
                </th>
                <th className='border-[1px] text-black text-center font-normal h-[40px] min-w-[150px]'>
                 Reference/Accession
                </th>
                <th className='border-[1px] text-black text-center font-normal h-[40px] min-w-[150px]'>
                 Comments
                </th>
              </tr>
        </thead>
        <tbody>
        {
              tableDataDetails.length>0 && tableDataDetails.map((item,index) => (
                <tr key={item.id} >
                  {samplePropertiesToShow.map((property) => (
                    <td key={property} className='p-0 text-[11px]'>
                      {property === "templateName" ? (
                        <div className='flex items-center justify-center h-[28px] text-center px-4 border-[1px]  w-full'>
                          {item[property]}
                        </div>
                      ) : property === "serviceOption" ? (
                        <div
                          className={`flex items-center justify-center h-[28px] text-center px-4 border-[1px]  w-full`}
                        >
                          {item[property]}
                        </div>
                      ) :  property === "sequencingPrimer" ? (
                        <div
                          className={`flex items-center justify-center h-[28px] text-center px-4 border-[1px]  w-full`}
                        >
                          {item[property]}
                        </div>
                      ) : property === "length" ? (
                        <div className='flex items-center justify-center h-[28px] text-center px-4 border-[1px]  w-full'>
                          {item[property]}
                        </div>
                      ) : 
                      property === "reference" ? (
                        <div className='flex items-center justify-center h-[28px] text-center px-4 border-[1px]  w-full'>
                          {item[property]}
                        </div>
                      ) 
                      : 
                      property === "comments" ? (
                        <div className='flex items-center justify-center h-[28px] text-center px-4 border-[1px]  w-full'>
                          {item[property]}
                        </div>
                      ) 
                      : 
                      property === "id" ? (
                        <div className='flex items-center justify-center h-[28px] text-center px-4 border-[1px]  w-full'>
                          {index+1}
                        </div>
                      )  : null}
                    </td>
                  ))}
                </tr>
              ))
             }
        </tbody>
      </table>
    )
  }

  const NgsTemplate = () => {
    const samplePropertiesToShow = [
      "id",
      "sampleID",
      "sampleType",
      "targetType",
      "targetSize",
      "dataAnalysis"
    ];

    return (
      <table className='border-1 w-full text-[12px]'>
        <thead>
            <tr>
                <th className='border-[1px] text-black text-center font-normal h-[40px] min-w-[30px] '>
                  #
                </th>
                <th className='border-[1px] text-black text-center font-normal h-[40px] min-w-[250px]'>
                Sample ID*
                </th>
                <th className='border-[1px] text-black text-center font-normal h-[40px] min-w-[220px]'>
                Sample Type*
                </th>
                <th className='border-[1px] text-black text-center font-normal h-[40px] min-w-[150px]'>
                Target Type*
                </th>               
                <th className='border-[1px] text-black text-center font-normal h-[40px] min-w-[120px]'>
                  {`Est. Target Size (kb)`}
                </th>
                <th className='border-[1px] text-black text-center font-normal h-[40px] min-w-[150px]'>
                Data Analysis*
                </th>
              </tr>
        </thead>
        <tbody>
        {
              tableDataDetails.length>0 && tableDataDetails.map((item,index) => (
                <tr key={item.id} >
                  {samplePropertiesToShow.map((property) => (
                    <td key={property} className='p-0 text-[11px]'>
                      {property === "sampleID" ? (
                        <div className='flex items-center justify-center h-[28px] text-center px-4 border-[1px]  w-full'>
                          {item[property]}
                        </div>
                      ) : property === "sampleType" ? (
                        <div
                          className={`flex items-center justify-center h-[28px] text-center px-4 border-[1px]  w-full`}
                        >
                          {item[property].label}
                        </div>
                      ) :  property === "targetType" ? (
                        <div
                          className={`flex items-center justify-center h-[28px] text-center px-4 border-[1px]  w-full`}
                        >
                          {item[property].label}
                        </div>
                      ) : property === "targetSize" ? (
                        <div className='flex items-center justify-center h-[28px] text-center px-4 border-[1px]  w-full'>
                          {item[property]}
                        </div>
                      ) : 
                      property === "dataAnalysis" ? (
                        <div className='flex items-center justify-center h-[28px] text-center px-4 border-[1px]  w-full'>
                          {item[property].label}
                        </div>
                      ) 
                      : 
                      property === "id" ? (
                        <div className='flex items-center justify-center h-[28px] text-center px-4 border-[1px]  w-full'>
                          {index+1}
                        </div>
                      )  : null}
                    </td>
                  ))}
                </tr>
              ))
             }
        </tbody>
      </table>
    )
  }

	const WpsaTemplate = () => {
		const samplePropertiesToShow = [
		"id",
		"dName",
		"dType",
		'dConc',
		"pcrSize",
		// "dataAnalysis"
		];
	
		return (
		<table className='border-1 w-full text-[12px]'>
		<thead>
			<tr>
				<th className='border-[1px] text-black text-center font-normal h-[40px] min-w-[30px] '>
					#
				</th>
				<th className='border-[1px] text-black text-center font-normal h-[40px] min-w-[250px]'>
					Sample ID
				</th>
				<th className='border-[1px] text-black text-center font-normal h-[40px] min-w-[200px]'>
					Sample Type
				</th>
				<th className='border-[1px] text-black text-center font-normal h-[40px] min-w-[120px]'>
					Sample Conc
				</th>
				<th className='border-[1px] text-black text-center font-normal h-[40px] min-w-[200px]'>
					{`Est. Target Size (kb)`}
				</th>
				{/* <th className='border-[1px] text-black text-center font-normal h-[40px] min-w-[150px]'>
					Data Analysis
				</th> */}
			</tr>
		</thead>
		<tbody>
		{
			data.TableData && data.TableData.map((item,index) => (
				<tr key={item.id} >
					{samplePropertiesToShow.map((property) => (
					<td key={property} className='p-0 text-[11px]'>
						{property === "dName" ? (
							<div className='flex items-center justify-center h-[28px] text-center px-4 border-[1px]  w-full'>
								{item[property]}
							</div>
						): property === "dConc" ? (
						<div className='flex items-center justify-center h-[28px] text-center px-4 border-[1px]  w-full'>
							{item[property] === null ? '-':item[property]}
						</div>
						) : property === "dType" ? (
						<div
							className={`flex items-center justify-center h-[28px] text-center px-4 border-[1px]  w-full`}
						>
							{item[property]}
						</div>
						) : property === "pcrSize" ? (
						<div className='flex items-center justify-center h-[28px] text-center px-4 border-[1px]  w-full'>
							{Number(item[property])/1000 < 1 ? item[property] : Number(item[property])/1000}
						</div>
						) : 
						property === "dataAnalysis" ? (
						<div className='flex items-center justify-center h-[28px] text-center px-4 border-[1px]  w-full'>
							{item[property]}
						</div>
						) 
						: 
						property === "id" ? (
						<div className='flex items-center justify-center h-[28px] text-center px-4 border-[1px]  w-full'>
							{index+1}
						</div>
						)  : null}
					</td>
					))}
				</tr>
			))
		}
		</tbody>
		</table>
	)
	}

  const GenomicTemplate = () => {
    // console.log(tableDataDetails[0].ampliconData);
    let dnaSamples = tableDataDetails
  
      return ( <>
        <div className='flex flex-col gap-[30px]'>
            {dnaSamples.map((item,key) => (
             <div key={key}>
                <div className='p-2 text-[12px] font-bold border-[1px] w-full bg-gray-100'>DNA Sample {key+1}</div>
                <div className='w-full border border-1 border-gray-300'>
                      <div className="flex items-center">
                          <p className='w-[215px] text-left text-[12px] px-2 py-[2px] font-bold border-r'>Gel Purification</p>
                          <p className='text-left text-[12px] px-2'>{item.purification}</p>         
                      </div>
                      <div className="flex items-center">
                          <p className=' w-[215px] text-left text-[12px] px-2 py-[2px] font-bold border-r '>Consensus Sequence</p>
                          <p className='text-left text-[12px] px-2'>{item.consensus}</p>         
                      </div>
                </div>
                <div className='flex gap-[20px] flex-wrap sm:justify-between'>
                {item.ampliconData.map((x,j) => (
                         <table key={j} className='w-full sm:w-[48%] sm:min-w-[400px]'>
                            <thead>
                                <th colSpan={2}
                                className='border border-1 border-gray-300 text-left text-[12px] px-2 py-2'
                                >AMPLICON #{j+1}</th>
                            </thead>
                            <tbody>
                                <tr>
                                    <th className='w-[30%] border border-1 border-gray-300  text-left text-[12px] px-2'>Gene of Interest</th>
                                    <td className='w-[70%] border border-1 border-gray-300 text-left text-[12px] px-2'>{x.gene}</td>         
                                </tr>
                                <tr>
                                    <th className=' border border-1 border-gray-300  text-left text-[12px] px-2 '>Location/Position</th>
                                    <td className=' border border-1 border-gray-300 text-left text-[12px] px-2'>{x.location}</td>         
                                </tr>   
                                <tr>
                                    <th className=' border border-1 border-gray-300  text-left text-[12px] px-2 '>Target Insert Length</th>
                                    <td className=' border border-1 border-gray-300 text-left text-[12px] px-2'>{x.targetLength}</td>         
                                </tr>   
                                <tr>
                                    <th className=' border border-1 border-gray-300  text-left text-[12px] px-2 '>Primers</th>
                                    <td className=' border border-1 border-gray-300 text-left text-[12px] px-2'>{x.primerDesign}</td>         
                                </tr>    
                                <tr>
                                    <th className=' border border-1 border-gray-300  text-left text-[12px] px-2 '>Forward Primer Name</th>
                                    <td className=' border border-1 border-gray-300 text-left text-[12px] px-2'>{x.forwardPrimerName}</td>         
                                </tr>   
                                <tr>
                                    <th className=' border border-1 border-gray-300  text-left text-[12px] px-2 '>Reverse Primer Name</th>
                                    <td className=' border border-1 border-gray-300 text-left text-[12px] px-2'>{x.reversePrimerName}</td>         
                                </tr>
                                <tr>
                                    <th className=' border border-1 border-gray-300  text-left text-[12px] px-2 '>Forward Primer Sequence</th>
                                    <td className=' border border-1 border-gray-300 text-left text-[12px] px-2'>{x.forwardPrimerSequence}</td>         
                                </tr>   
                                <tr>
                                    <th className=' border border-1 border-gray-300  text-left text-[12px] px-2 '>Reverse Primer Sequence</th>
                                    <td className=' border border-1 border-gray-300 text-left text-[12px] px-2'>{x.reversePrimerSequence}</td>         
                                </tr>
                                <tr>
                                    <th className=' border border-1 border-gray-300  text-left text-[12px] px-2 '>Additional Comments</th>
                                    <td className=' border border-1 border-gray-300 text-left text-[12px] px-2'>{x.comments}</td>         
                                </tr>

                            </tbody>
                        </table>
                ))}    
                </div>
             </div>   
            ))}
        </div>
      </>
      )
  }


  const PrimerDataTemplate = () => {
    const primerPropertiesToShow = [
      "prId",
      "primName",
      "primSeq",

    ];
    return (
      <table className='border-1  w-full text-[12px]'>
            <thead>
              <tr>
                <th className='border-[1px] text-black text-center font-normal min-w-[30px] h-[40px]'>
                  #
                </th>
                <th className='border-[1px] text-black text-center font-normal min-w-[150px] h-[40px]'>
                  Primer Name
                </th>
                <th className='border-[1px] text-black text-center font-normal min-w-[150px] h-[40px]'>
                  Primer Sequence
                </th>
              </tr>
            </thead>
            <tbody>
             {
              data.PrimerSynthesisList && data.PrimerSynthesisList.map((item, index) => (
                <tr key={index} >
                  {primerPropertiesToShow.map((property) => (
                    <td key={property} className='p-0 text-[11px]'>
                      {property === "primName" ? (
                        <div className='flex items-center h-[28px] px-4 border-[1px] border w-full'>
                          {item[property]}
                        </div>
                      ) : 
                      property === "prId" ? (
                        <div className='flex items-center justify-center text-center h-[28px] px-4 border-[1px] w-full'>
                          {index+1}
                        </div>
                      ) : 
                      property === "primSeq" ? (
                        <div className='flex items-center h-[28px] px-4 border-[1px] border w-full'>
                          {item[property]}
                        </div>
                      ) : null}
                    </td>
                  ))}
                </tr>
              ))
             }
            </tbody>
          </table>
    )
  }

  useEffect(() => {
    document.documentElement.classList.add('no-scroll');
    document.body.classList.add('no-scroll');

    return () => {
      document.documentElement.classList.remove('no-scroll');
      document.body.classList.remove('no-scroll');
    };
  }, []);


  let [userCode, setUserCode] = useState(0)
  let [codeError, setCodeError] = useState(false)
  let codeFromDb = loc.search.split('=')[2]
  
  // console.log(codeFromDb);


  function verifyUserCode(){
    if(userCode === codeFromDb){
      // console.log('pass');
      document.documentElement.classList.remove('no-scroll');
      document.body.classList.remove('no-scroll');
      document.getElementById('codeBox').style.display = 'none'
    }
    else{
      setCodeError(true)
    }
  }


  function submitCcDetails(x){
    // console.log(ccDetails);

    let data4 = {
      pData: ccDetails,
      billData: billingInfo,
      oType: data.OrderTypeId
    }

    try {

      fetch(`${url}/api/orderForm/submitPaData?orderNumber=${x}`, {
        method: 'PUT',
        credentials: 'include',
        headers: {
          // Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data4)
      }
      )
      .then((res) => res.json())
      .then((data5) => {
        // console.log('update', data5);
        if(data5.message === "Success"){
          // alert("Success")
          setShowCompletion(true)
        }
      })
      .catch(err => {
        console.error(err);
      })  

      
      
    } catch (error) {
      console.error(error);
      
    }
    
  }


  function getNonEmptyDataCount(x){
    let lvTable = x 
    
    // console.log("lvTable",lvTable);
    
    let count = 0
    for(let i=0; i<lvTable.length; i++){
      if(lvTable[i].dName !== null && lvTable[i].dName !== "" && lvTable[i].dName !== "water" && lvTable[i].dName !== "empty" && lvTable[i].dName !== "CONTROL"){
        count++
      }
    }

    return count
  }

  function getConsensusCount(x){
    let tData2 = x
    let dnaNamesArray = []

    for(let i=0; i<tData2.length; i++){
      dnaNamesArray.push(tData2[i].dName)
    }

    const countMap = dnaNamesArray.reduce((acc, item) => {
      acc[item] = (acc[item] || 0) + 1;
      return acc;
    }, {});
    
    const categoryCount = Object.values(countMap).filter(count => count > 1).length;

    // console.log("CC",categoryCount);

    return categoryCount
  }

	const discountTemplate = () => {
	return (
		data.confirmreward !== 0 && 
		<>
		<tr>
			<td  className="border border-1 px-2">Discount Applied {data.confirmreward === 1 ? `(${data.discount_code})` : `(${data.discount_code} -- ${data.discount_type === 1 ? `$${data.discount_value} Off` : `${data.discount_value}% ${Number(data.discount_upto) > 0 ? `or up to $${data.discount_upto} Off`:'Off'}`} )`} </td>
			<td id="subTotal102" colSpan={3} className="border border-1 text-right px-2">{data.confirmreward === 1 ? getDiscountPrice(0, 'Sanger_Validation') :getDiscountPrice(data.discount_value, data.discount_type)}</td>
		</tr>
		<tr>
			<td className="border border-1 px-2 font-semibold">FINAL</td>
			<td colSpan={3} className="border border-1 text-right px-2 font-semibold">{getFinalPrice()}</td>
		</tr>
		</>
	)
	}

  return (
    <>
    <style>
        {`
          .no-scroll {
            overflow: hidden;
          }
        `}
    </style>
    
    { data && !Array.isArray(data) && linkExpiredMessage === false && showCompletion === false && alreadyPaid === false?
    <>
      <div id="codeBox">
      <div className="fixed inset-0 w-full h-full bg-black opacity-60">
      </div>
      <div className="w-[400px] rounded-2xl h-[200px] bg-gray-300 fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex justify-center items-center">
        <div className="flex w-[80%] flex-col items-center gap-[10px]">
          <p className="text-[18px]">Enter Code</p>
          <input 
          type="text" 
          className="border border-1 border-black text-center" 
          maxLength={4}
          onKeyDown={(e) => {
            if(e.key === "Enter"){
              verifyUserCode()
            }
          }}
          onChange={(event) => {
            setCodeError(false)

            event.target.value = event.target.value.replace(/\D/g, "");

                if (event.target.value.length > 4) {
                  event.target.value = event.target.value.slice(0, 4);
                }
            
            setUserCode(event.target.value)
          }}
          />
          <button 
          className="mt-2 border-2 border-[#302a7e] rounded-3xl font-bold gap-2 text-[var(--color-primary-purple)] bg-white uppercase px-8"
          onClick={verifyUserCode}
          >Submit</button>
        {codeError && <span className="text-[13px] text-red-500 font-bold">Code is incorrect.</span>}
        </div>
      </div>
    </div>
       <div id="paymentData" className="px-16 py-4 pb-40">
        <h1 className="font-semibold text-xl">PA Confirmation of Payment - Order#: {parseInt(data.OrderId)+600000}</h1>
        <p className="text-sm mt-2">* This link will expire on <span className="font-semibold">{validity}</span>. Please complete payment information and submit prior to the date provided above. Should you need to renew the link with a new passcode, please contact customer support at sanger@acgtinc.com or (800) 557-2248.</p>
      
        <p className="text-[12px] mt-5">Accountant(PA)</p>
        <div className="border border-1 text-[12px]  py-3 px-8 flex flex-col gap-5">
            <div className="flex w-full gap-[20px]">
                <p className="w-[25%] text-right">Contact Name:</p>
                <input 
                  className="border border-1 w-[250px] px-2" 
                  type="text"
                  value={ccDetails.paName}
                  onChange={(event) => {

                    setCcDetails({
                      ...ccDetails,
                      paName: event.target.value
                    })
                  }}
                />
            </div>
            <div className="flex w-full gap-[20px]">
                <p className="w-[25%] text-right">Contact Email:</p>
                <div className="flex flex-col gap-[5px]">
                  <input 
                    className="border border-1 w-[250px] px-2" 
                    type="email"
                    value={ccDetails.paEmail}
                    onChange={(event) => {

                      setCcDetails({
                        ...ccDetails,
                        paEmail: event.target.value
                      })
                    }}
                  />
                  <p className="flex-1">*The contact email address must match the email address that received the order confirmation email from ACGT.</p>
                </div>
                
            </div>
            <div className="flex w-full gap-[20px]">
                <p className="w-[25%] text-right">Contact Phone:</p>
                <input 
                    className="border border-1 w-[250px] px-2" 
                    type="text"
                    value={ccDetails.paPhone}
                    onChange={(event) => {

                      setCcDetails({
                        ...ccDetails,
                        paPhone: event.target.value
                      })
                    }}
                  />
            </div>
        </div>

        <div className="px-8 mb-1 w-full mt-6 text-[12px] flex items-center gap-5">
          <p className="w-[25%] text-right">Payment Option</p>
          <div className="w-[200px]">
            <select name="paymentoption" className="w-full" onChange={(e) => {
              setCcDetails({
                ...ccDetails,
                paymentType: e.target.value
              })}}>
              <option value="cc">Credit Card</option>
              <option value="po">PO</option>
            </select>
          </div>
        </div>

        {ccDetails.paymentType === 'cc' && 
          <div className="border border-1 text-[12px]  py-3 px-8 flex flex-col gap-5">
              <div className="flex w-full gap-[20px]">
                  <p className="w-[25%] text-right">Card Number:</p>
                  <input 
                  className="border border-1 w-[200px] px-2" 
                  type="text"
                  value={ccDetails.cardNumber}
                  maxLength={16}
                  onChange={(event) => {

                    event.target.value = event.target.value.replace(/\D/g, "");

                    if (event.target.value.length > 16) {
                      event.target.value = event.target.value.slice(0, 16);
                    }

                    setCcDetails({
                      ...ccDetails,
                      cardNumber: event.target.value
                    })
                  }}
                  />
              </div>
              <div className="flex w-full gap-[20px]">
                  <p className="w-[25%] text-right">Card Type:</p>
                  <div className="w-[200px]">
                    <select 
                    name="cardType" 
                    className="w-full"
                    defaultValue={'#'}
                    onChange={(event) => {
                      setCcDetails({
                        ...ccDetails,
                        cardType: event.target.value
                      })
                    }}
                    >
                      <option value="#" disabled>Select One</option>
                      <option value="Visa">Visa</option>
                      <option value="Mastercard">Mastercard</option>
                      <option value="Discover">Discover</option>
                    </select>
                  </div>
              </div>
              <div className="flex w-full gap-[20px]">
                  <p className="w-[25%] text-right">Expiry Date:</p>
                  
                  <div className="flex gap-[10px]">
                    <input 
                    className="border border-1 w-[40px] px-2" 
                    type="text"
                    value={ccDetails.expMonth}
                    maxLength={2}
                    onChange={(event) => {

                      event.target.value = event.target.value.replace(/\D/g, "");

                      if (event.target.value.length > 2) {
                        event.target.value = event.target.value.slice(0, 2);
                      }

                      setCcDetails({
                        ...ccDetails,
                        expMonth: event.target.value
                      })
                    }}
                    />
                    <p className="flex-1">/</p>
                    <input 
                    className="border border-1 w-[60px] px-2" 
                    type="text"
                    value={ccDetails.expYear}
                    maxLength={4}
                    onChange={(event) => {

                      event.target.value = event.target.value.replace(/\D/g, "");

                      if (event.target.value.length > 4) {
                        event.target.value = event.target.value.slice(0, 4);
                      }

                      setCcDetails({
                        ...ccDetails,
                        expYear: event.target.value
                      })
                    }}
                    />
                    <p className="flex-1">(MM/YYYY)</p>
                  </div>
              </div>
                  
              <div className="flex w-full gap-[20px]">
                  <p className="w-[25%] text-right">CVS Code:</p>
                  <input 
                  className="border border-1 w-[60px] px-2" 
                  type="text"
                  value={ccDetails.ccv}
                  maxLength={3}
                  onChange={(event) => {

                    event.target.value = event.target.value.replace(/\D/g, "");

                    if (event.target.value.length > 3) {
                      event.target.value = event.target.value.slice(0, 3);
                    }

                    setCcDetails({
                      ...ccDetails,
                      ccv: event.target.value
                    })
                  }}
                  />
              </div>
              <div className="flex w-full gap-[20px]">
                  <p className="w-[25%] text-right">{`Card Holder's Name:`}</p>
                  <input 
                  className="border border-1 w-[200px] px-2" 
                  type="text"
                  value={ccDetails.cardHolder}
                  onChange={(event) => {

                    setCcDetails({
                      ...ccDetails,
                      cardHolder: event.target.value
                    })
                  }}
                  />
              </div>
              <div className="flex w-full gap-[20px]">
                  <p className="w-[25%] text-right">{`Card Holder's ZIP Code:`}</p>
                  <input 
                  className="border border-1 w-[80px] px-2" 
                  type="text"
                  value={ccDetails.zip}
                  maxLength={5}
                  onChange={(event) => {

                    event.target.value = event.target.value.replace(/\D/g, "");

                    if (event.target.value.length > 3) {
                      event.target.value = event.target.value.slice(0, 5);
                    }

                    setCcDetails({
                      ...ccDetails,
                      zip: event.target.value
                    })
                  }}
                  />
              </div>

              <div className="flex w-full gap-[20px] mt-5">
                  <p className="w-[25%] text-right">Memo:</p>
                  <textarea 
                  className="border border-1 w-[300px] px-2"
                  rows={3} 
                  type="text"
                  value={ccDetails.memo}
                  onChange={(event) => {

                    setCcDetails({
                      ...ccDetails,
                      memo: event.target.value
                    })
                  }}
                  />
              </div>
          </div>
        }

        {ccDetails.paymentType === 'po' && 
          <div className="border border-1 text-[12px]  py-3 px-8 flex flex-col gap-5">   
              <div className="flex w-full gap-[20px]">
                  <p className="w-[25%] text-right">PO Number:</p>
                  <input 
                  className="border border-1 w-[200px] px-2" 
                  type="text"
                  value={ccDetails.po}
                  onChange={(event) => {

                    setCcDetails({
                      ...ccDetails,
                      po: event.target.value
                    })
                  }}
                  />
              </div>

              <div className="flex w-full gap-[20px] mt-5">
                  <p className="w-[25%] text-right">Memo:</p>
                  <textarea 
                  className="border border-1 w-[300px] px-2"
                  rows={3} 
                  type="text"
                  value={ccDetails.memo}
                  onChange={(event) => {

                    setCcDetails({
                      ...ccDetails,
                      memo: event.target.value
                    })
                  }}
                  />
              </div>
          </div>
        }


        <button
        onClick={() => submitCcDetails(data.OrderId)}
        className="border border-1  px-8 my-4 text-[14px] bg-gray-200">Submit</button>  
        

        <div>
          <p className="text-[12px]">Price Information</p>
          {data.OrderTypeId === 25 ?
            <div className="w-full">
              <table className='w-full mt-2 text-[12px]'>
                <tbody>
                <tr>
                      <th className='w-[34%] font-normal border border-1 px-2 text-center'>Item</th>
                      <th className='w-[22%] font-normal border border-1 px-2 text-center'>Unit</th>
                      <th className='w-[22%] font-normal border border-1 px-2 text-center'>Qty</th>
                      <th className='w-[22%] font-normal border border-1 px-2 text-center'>SubTotal</th>                
                  </tr> 
                  <tr>
                    <td className="border border-1 px-2">{data.ServiceType}</td>
                    <td className="border border-1 text-right px-2">${data.ServiceType ? getPrice(data.OrderType, data.ServiceType) : 0}</td>
                    <td className="border border-1 text-right px-2">{data.TableData ? data.TableData.length : 0}</td>
                    <td id="subTotal1" className="border border-1 text-right px-2">${data.ServiceType ? getPrice(data.OrderType, data.ServiceType) * data.TableData.length : 0 } </td>
                  </tr>
                  {purifRow.bool === true && 
                  <tr>
                    <td className="border border-1 px-2">PCR Purification</td>
                    <td className="border border-1 text-right px-2">${getPrice('General', 'PCRT')}</td>
                    <td className="border border-1 text-right px-2">{purifRow.qty}</td>
                    <td id="subTotal2" className="border border-1 text-right px-2">${getPrice('General', 'PCRT') * purifRow.qty} </td>
                  </tr>
                  }
                  {bacRow.bool === true && 
                  <tr>
                    <td className="border border-1 px-2">BAC DNA</td>
                    <td className="border border-1 text-right px-2">$30</td>
                    <td className="border border-1 text-right px-2">{bacRow.qty}</td>
                    <td id="subTotal3" className="border border-1 text-right px-2">${30 * bacRow.qty} </td>
                  </tr>
                  }
                  {cosmidRow.bool === true && 
                  <tr>
                    <td className="border border-1 px-2">Cosmid</td>
                    <td className="border border-1 text-right px-2">$30</td>
                    <td className="border border-1 text-right px-2">{cosmidRow.qty}</td>
                    <td id="subTotal4" className="border border-1 text-right px-2">${30 * cosmidRow.qty} </td>
                  </tr>
                  }
                  {hgcRow.bool === true && 
                  <tr>
                    <td className="border border-1 px-2">High GC</td>
                    <td className="border border-1 text-right px-2">${getPrice('General', 'HGC')}</td>
                    <td className="border border-1 text-right px-2">{hgcRow.qty}</td>
                    <td id="subTotal5" className="border border-1 text-right px-2">${getPrice('General', 'HGC') * hgcRow.qty} </td>
                  </tr>
                  }
                  {hairpinRow.bool === true && 
                  <tr>
                    <td className="border border-1 px-2">Hairpin</td>
                    <td className="border border-1 text-right px-2">${getPrice('General', 'HP')}</td>
                    <td className="border border-1 text-right px-2">{hairpinRow.qty}</td>
                    <td id="subTotal6" className="border border-1 text-right px-2">${getPrice('General', 'HP') * hairpinRow.qty} </td>
                  </tr>
                  }
                  {(data.iTurnAroundTime === 2 || data.iTurnAroundTime === 4) && 
                  <tr>
                    <td className="border border-1 px-2">{data.iTurnAroundTime === 4 ? 'Rush Order Service':'Same Day Service'}</td>
                    <td className="border border-1 text-right px-2">${getPrice('General', 'SDS')}</td>
                    <td className="border border-1 text-right px-2">{data.TableData ? data.TableData.length : 0}</td>
                    <td id="subTotal7" className="border border-1 text-right px-2">${getPrice('General', 'SDS') * data.TableData.length} </td>
                  </tr>
                  }
                  {data.Consensus === 1 && 
                  <tr>
                    <td className="border border-1 px-2">Consensus</td>
                    <td className="border border-1 text-right px-2">${getPrice('General', 'Consensus')}</td>
                    <td className="border border-1 text-right px-2">{getConsensusCount(data.TableData)}</td>
                    <td id="subTotal8" className="border border-1 text-right px-2">${getPrice('General', 'Consensus') * getConsensusCount(data.TableData)} </td>
                  </tr>
                  }
                  {
                    primerRow.bool === true && 
                    <tr>
                      <td className="border border-1 px-2">{primerRow.label==="PSPD"? `Primer Design and Synthesis`:`Primer Synthesis`}</td>
                      <td className="border border-1 text-right px-2">${getPrice('General', primerRow.label)}</td>
                      <td className="border border-1 text-right px-2">{primerRow.count}</td>
                      <td id="subTotal9" className="border border-1 text-right px-2">${getPrice('General', primerRow.label) * primerRow.count} </td>
                  </tr>
                  }
                  <tr>
                    <td className="border border-1 px-2 font-semibold">Total</td>
					<td id="subTotal101" colSpan={3} className="border border-1 text-right px-2 font-semibold">{getTotalPrice()}</td>
				</tr>
				
				{discountTemplate()}
				
                </tbody>
                
              </table>
            </div>
          : 
          data.OrderTypeId === 34 ? 
            <div className="w-full">
              <table className='w-full mt-2 text-[12px]'>
                <tbody>
                <tr>
                      <th className='w-[34%] font-normal border border-1 px-2 text-center'>Item</th>
                      <th className='w-[22%] font-normal border border-1 px-2 text-center'>Unit</th>
                      <th className='w-[22%] font-normal border border-1 px-2 text-center'>Qty</th>
                      <th className='w-[22%] font-normal border border-1 px-2 text-center'>SubTotal</th>                
                  </tr> 
                  <tr>
                    <td className="border border-1 px-2">Direct Colony Sequencing Service</td>
                    <td className="border border-1 text-right px-2">${getPrice("Single Pass", "Premium Service")}</td>
                    <td className="border border-1 text-right px-2">{data.TableData ? data.TableData.length : 0}</td>
                    <td id="subTotal1" className="border border-1 text-right px-2">${getPrice("Single Pass", "Premium Service") * data.TableData.length} </td>
                  </tr>

                  {
                  dcssPrepRow.bool === true &&
                    <tr>
                      <td className="border border-1 px-2">Amplification</td>
                      <td className="border border-1 text-right px-2">${getPrice("Direct Colony", "DCSS")}</td>
                      <td className="border border-1 text-right px-2">{dcssPrepRow.qty}</td>
                      <td id="subTotal2" className="border border-1 text-right px-2">${getPrice("Direct Colony", "DCSS") * dcssPrepRow.qty} </td>
                    </tr>
                  }

                  {
                  agarPrepRow.bool === true &&
                    <tr>
                      <td className="border border-1 px-2">Colony on Agar Plate</td>
                      <td className="border border-1 text-right px-2">$1.50</td>
                      <td className="border border-1 text-right px-2">{agarPrepRow.qty}</td>
                      <td id="subTotal3" className="border border-1 text-right px-2">${1.5 * agarPrepRow.qty} </td>
                    </tr>
                  }
                
                  {(data.iTurnAroundTime === 2 || data.iTurnAroundTime === 4) && 
                  <tr>
                    <td className="border border-1 px-2">Same Day Service</td>
                    <td className="border border-1 text-right px-2">${getPrice('General', 'SDS')}</td>
                    <td className="border border-1 text-right px-2">{data.TableData ? data.TableData.length : 0}</td>
                    <td id="subTotal4" className="border border-1 text-right px-2">${getPrice('General', 'SDS') * data.TableData.length} </td>
                  </tr>
                  }
                  
                  {
                    primerRow.bool === true && 
                    <tr>
                      <td className="border border-1 px-2">{primerRow.label==="PSPD"? `Primer Design and Synthesis`:`Primer Synthesis`}</td>
                      <td className="border border-1 text-right px-2">${getPrice('General', primerRow.label)}</td>
                      <td className="border border-1 text-right px-2">{primerRow.count}</td>
                      <td id="subTotal5" className="border border-1 text-right px-2">${getPrice('General', primerRow.label) * primerRow.count} </td>
                  </tr>
                  }
                  <tr>
                    <td className="border border-1 px-2 font-semibold">Total</td>
						<td id="subTotal101" colSpan={3} className="border border-1 text-right px-2 font-semibold">{getTotalPrice()}</td>
					</tr>
					
					{discountTemplate()}
					
                </tbody>
                
              </table>
            </div>
          :
          data.OrderTypeId === 28 ? 
            <div className="w-full">
                <table className='w-full mt-2 text-[12px]'>
                  <tbody>
                  <tr>
                        <th className='w-[34%] font-normal border border-1 px-2 text-center'>Item</th>
                        <th className='w-[22%] font-normal border border-1 px-2 text-center'>Unit</th>
                        <th className='w-[22%] font-normal border border-1 px-2 text-center'>Qty</th>
                        <th className='w-[22%] font-normal border border-1 px-2 text-center'>SubTotal</th>                
                    </tr> 
                    <tr>
                      <td className="border border-1 px-2">High Throughput</td>
						<td className="border border-1 text-right px-2">${getPrice("Large Volume", `${(data.Ordertype === 2)? 'Premium Service': data.ServiceType}-FP${getNonEmptyDataCount(data.TableData) >= 96 ? '96' : '48'}`)}</td>
                      <td className="border border-1 text-right px-2">{data.TableData ? getNonEmptyDataCount(data.TableData) : 0}</td>
						<td id="subTotal1" className="border border-1 text-right px-2">${(getPrice("Large Volume", `${(data.Ordertype === 2)? 'Premium Service': data.ServiceType}-FP${getNonEmptyDataCount(data.TableData) >= 96 ? '96' : '48'}`) * getNonEmptyDataCount(data.TableData)).toFixed(2)} </td>
                    </tr>

                    {
                    purifRow.bool === true &&
                      <tr>
                        <td className="border border-1 px-2">PCR Purification</td>
                        <td className="border border-1 text-right px-2">${getPrice("General", "PCRT")}</td>
                        <td className="border border-1 text-right px-2">{purifRow.qty}</td>
                        <td id="subTotal2" className="border border-1 text-right px-2">${(getPrice('General', 'PCRT') * purifRow.qty).toFixed(2)} </td>
                      </tr>
                    }

                    {
                    bacRow.bool === true &&
                      <tr>
                        <td className="border border-1 px-2">BAC DNA</td>
                        <td className="border border-1 text-right px-2">$30.00</td>
                        <td className="border border-1 text-right px-2">{bacRow.qty}</td>
                        <td id="subTotal3" className="border border-1 text-right px-2">${(30 * bacRow.qty).toFixed(2)} </td>
                      </tr>
                    }

                    {
                    cosmidRow.bool === true &&
                      <tr>
                        <td className="border border-1 px-2">Cosmid DNA</td>
                        <td className="border border-1 text-right px-2">$30.00</td>
                        <td className="border border-1 text-right px-2">{cosmidRow.qty}</td>
                        <td id="subTotal4" className="border border-1 text-right px-2">${(30 * cosmidRow.qty).toFixed(2)} </td>
                      </tr>
                    }

                  
                  {hgcRow.bool === true && 
                    <tr>
                      <td className="border border-1 px-2">High GC</td>
                      <td className="border border-1 text-right px-2">${getPrice('General', 'HGC')}</td>
                      <td className="border border-1 text-right px-2">{hgcRow.qty}</td>
                      <td id="subTotal5" className="border border-1 text-right px-2">${getPrice('General', 'HGC') * hgcRow.qty} </td>
                    </tr>
                    }

                    {hairpinRow.bool === true && 
                    <tr>
                      <td className="border border-1 px-2">Hairpin</td>
                      <td className="border border-1 text-right px-2">${getPrice('General', 'HP')}</td>
                      <td className="border border-1 text-right px-2">{hairpinRow.qty}</td>
                      <td id="subTotal6" className="border border-1 text-right px-2">${getPrice('General', 'HP') * hairpinRow.qty} </td>
                    </tr>
                    }
                    
                    {
                      primerRow.bool === true && 
                      <tr>
                        <td className="border border-1 px-2">{primerRow.label==="PSPD"? `Primer Design and Synthesis`:`Primer Synthesis`}</td>
                        <td className="border border-1 text-right px-2">${getPrice('General', primerRow.label)}</td>
                        <td className="border border-1 text-right px-2">{primerRow.count}</td>
                        <td id="subTotal7" className="border border-1 text-right px-2">${getPrice('General', primerRow.label) * primerRow.count} </td>
                    </tr>
                    }
                    {
                    dcssPrepRow.bool === true &&
                      <tr>
                        <td className="border border-1 px-2">Amplification</td>
                        <td className="border border-1 text-right px-2">${getPrice("Direct Colony", "DCSS")}</td>
                        <td className="border border-1 text-right px-2">{dcssPrepRow.qty}</td>
                        <td id="subTotal8" className="border border-1 text-right px-2">${getPrice("Direct Colony", "DCSS") * dcssPrepRow.qty} </td>
                      </tr>
                    }
                    {
                    agarPrepRow.bool === true &&
                      <tr>
                        <td className="border border-1 px-2">Colony on Agar Plate</td>
                        <td className="border border-1 text-right px-2">$1.5</td>
                        <td className="border border-1 text-right px-2">{agarPrepRow.qty}</td>
                        <td id="subTotal9" className="border border-1 text-right px-2">${1.5 * agarPrepRow.qty} </td>
                      </tr>
                    }
                    <tr>
                      <td className="border border-1 px-2 font-semibold">Total</td>
						<td id="subTotal101" colSpan={3} className="border border-1 text-right px-2 font-semibold">{getTotalPrice()}</td>
					</tr>
					
					{discountTemplate()}
					
                  </tbody>
                  
                </table>
            </div>
			:
			data.OrderTypeId === 38 ? 
				<div className="w-full">
					<table className='w-full mt-2 text-[12px]'>
						<tbody>
						<tr>
							<th className='w-[34%] font-normal border border-1 px-2 text-center'>Item</th>
							<th className='w-[22%] font-normal border border-1 px-2 text-center'>Unit</th>
							<th className='w-[22%] font-normal border border-1 px-2 text-center'>Qty</th>
							<th className='w-[22%] font-normal border border-1 px-2 text-center'>SubTotal</th>                
						</tr> 
						<tr>
							<td className="border border-1 px-2">Fragment Length Analysis</td>
							<td className="border border-1 text-right px-2">${flaPlatePrice}</td>
							<td className="border border-1 text-right px-2">{data.TableData ? Number(data.TableData.length)/96 : 0}</td>
							<td id="subTotal1" className="border border-1 text-right px-2">${(flaPlatePrice * Number(data.TableData.length)/96).toFixed(2)} </td>
						</tr>

						{
						stagingRow.bool === true &&
						<tr>
							<td className="border border-1 px-2">Sample Staging</td>
							<td className="border border-1 text-right px-2">${sampleStagingPrice}</td>
							<td className="border border-1 text-right px-2">{stagingRow.qty}</td>
							<td id="subTotal2" className="border border-1 text-right px-2">${(sampleStagingPrice * stagingRow.qty).toFixed(2)} </td>
						</tr>
						}

						{
						analysisBasicRow.bool === true &&
						<tr>
							<td className="border border-1 px-2">BASIC Peak Profles</td>
							<td className="border border-1 text-right px-2">${basicPeak}</td>
							<td className="border border-1 text-right px-2">{analysisBasicRow.qty}</td>
							<td id="subTotal3" className="border border-1 text-right px-2">${(basicPeak * analysisBasicRow.qty).toFixed(2)} </td>
						</tr>
						}
	
						{
						analysisGenePrintRow.bool === true &&
						<tr>
							<td className="border border-1 px-2">GenePrint 10/24 Analysis</td>
							<td className="border border-1 text-right px-2">${genePrint}</td>
							<td className="border border-1 text-right px-2">{analysisGenePrintRow.qty}</td>
							<td id="subTotal4" className="border border-1 text-right px-2">${(genePrint * analysisGenePrintRow.qty).toFixed(2)} </td>
						</tr>
						}
	
						<tr>
							<td className="border border-1 px-2 font-semibold">Total</td>
							<td id="subTotal101" colSpan={3} className="border border-1 text-right px-2 font-semibold">{getTotalPrice()}</td>
						</tr>
	
						{discountTemplate()}
						
					</tbody>
					
					</table>
			</div>
			:
          data.OrderTypeId === 29 ? 
            <div className="w-full">
                <table className='w-full mt-2 text-[12px]'>
                  <tbody>
                  <tr>
                        <th className='w-[34%] font-normal border border-1 px-2 text-center'>Item</th>
                        <th className='w-[22%] font-normal border border-1 px-2 text-center'>Unit</th>
                        <th className='w-[22%] font-normal border border-1 px-2 text-center'>Qty</th>
                        <th className='w-[22%] font-normal border border-1 px-2 text-center'>SubTotal</th>                
                    </tr> 
                    <tr>
                      <td className="border border-1 px-2">Single Stranded Sequencing</td>
                      <td className="border border-1 text-right px-2">${fsa_ssPrice}</td>
                      <td className="border border-1 text-right px-2">{data.OrderDetails ? getFsaCount('Single Stranded') : 0}</td>
                      <td id="subTotal1" className="border border-1 text-right px-2">${(fsa_ssPrice * getFsaCount('Single Stranded')).toFixed(2)} </td>
                    </tr>
                    <tr>
                      <td className="border border-1 px-2">Double Stranded Sequencing</td>
                      <td className="border border-1 text-right px-2">${fsa_dsPrice}</td>
                      <td className="border border-1 text-right px-2">{data.OrderDetails ? getFsaCount('Double Stranded') : 0}</td>
                      <td id="subTotal2" className="border border-1 text-right px-2">${(fsa_dsPrice * getFsaCount('Double Stranded')).toFixed(2)} </td>
                    </tr>
                    <tr>
                      <td className="border border-1 px-2">Primer Synthesis Without Design</td>
                      <td className="border border-1 text-right px-2">${fsa_psndPrice}</td>
                      <td className="border border-1 text-right px-2">{data.OrderDetails ? getFsaCount('PSND') : 0}</td>
                      <td id="subTotal3" className="border border-1 text-right px-2">${(fsa_psndPrice * (data.OrderDetails ? getFsaCount('PSND') : 0)).toFixed(2)} </td>
                    </tr>
                    <tr>
                      <td className="border border-1 px-2">Primer Synthesis Plus Design</td>
                      <td className="border border-1 text-right px-2">${fsa_pspdPrice}</td>
                      <td className="border border-1 text-right px-2">{data.OrderDetails ? getFsaCount('PSPD') : 0}</td>
                      <td id="subTotal4" className="border border-1 text-right px-2">${(fsa_pspdPrice * (data.OrderDetails ? getFsaCount('PSPD') : 0)).toFixed(2)} </td>
                    </tr>
                    <tr>
                      <td className="border border-1 px-2">Project Management Fee</td>
                      <td className="border border-1 text-right px-2">15% of Total</td>
                      <td className="border border-1 text-right px-2"> - </td>
                      <td className="border border-1 text-right px-2">${(parseFloat(getTotalPrice().split('$')[1]) * 0.15).toFixed(2)} </td>
                    </tr>
                      
                    <tr>
                      <td className="border border-1 px-2 font-semibold">Total</td>
                      <td colSpan={3} className="border border-1 text-right px-2 font-semibold">${(parseFloat(getTotalPrice().split('$')[1]) * 1.15).toFixed(2)}</td>
                    </tr>
                  </tbody>
                  
                </table>
            </div>
          :
          data.OrderTypeId === 37 ? 
            <div className="w-full">
                <table className='w-full mt-2 text-[12px]'>
                  <tbody>
                  <tr>
                        <th className='w-[34%] font-normal border border-1 px-2 text-center'>Item</th>
                        <th className='w-[22%] font-normal border border-1 px-2 text-center'>Unit</th>
                        <th className='w-[22%] font-normal border border-1 px-2 text-center'>Qty</th>
                        <th className='w-[22%] font-normal border border-1 px-2 text-center'>SubTotal</th>                
                    </tr> 
                    {getNgsCount(11) > 0 && 
                    <tr>
                      <td className="border border-1 px-2">Purified DNA, 100 to 550bp -- PCR Product -- Direct Amplicon Variant Binning</td>
                      <td className="border border-1 text-right px-2">${pr11}</td>
                      <td className="border border-1 text-right px-2">{data.OrderDetails ? getNgsCount(11) : 0}</td>
                      <td id="subTotal1" className="border border-1 text-right px-2">${(pr11 * getNgsCount(11)).toFixed(2)} </td>
                    </tr>
                    }
                    {getNgsCount(12) > 0 && 
                    <tr>
                      <td className="border border-1 px-2">Purified DNA, 100 to 550bp -- PCR Product -- 16S rRNA Metagenomics</td>
                      <td className="border border-1 text-right px-2">${pr12}</td>
                      <td className="border border-1 text-right px-2">{data.OrderDetails ? getNgsCount(12) : 0}</td>
                      <td id="subTotal2" className="border border-1 text-right px-2">${(pr12 * getNgsCount(12)).toFixed(2)} </td>
                    </tr>
                    }
                    {getNgsCount(13) > 0 && 
                    <tr>
                      <td className="border border-1 px-2">Purified DNA, 100 to 550bp -- PCR Product -- ITS Metagenomics</td>
                      <td className="border border-1 text-right px-2">${pr13}</td>
                      <td className="border border-1 text-right px-2">{data.OrderDetails ? getNgsCount(13) : 0}</td>
                      <td id="subTotal3" className="border border-1 text-right px-2">${(pr13 * getNgsCount(13)).toFixed(2)} </td>
                    </tr>
                    }
                    {getNgsCount(14) > 0 && 
                    <tr>
                      <td className="border border-1 px-2">Purified DNA, 100 to 550bp -- PCR Product -- 16S/ITS Metagenomics</td>
                      <td className="border border-1 text-right px-2">${pr14}</td>
                      <td className="border border-1 text-right px-2">{data.OrderDetails ? getNgsCount(14) : 0}</td>
                      <td id="subTotal4" className="border border-1 text-right px-2">${(pr14 * getNgsCount(14)).toFixed(2)} </td>
                    </tr>
                    }
                    {getNgsCount(21) > 0 && 
                    <tr>
                      <td className="border border-1 px-2">Purified DNA {'>'} 550bp -- PCR Product -- Map to Reference</td>
                      <td className="border border-1 text-right px-2">${pr21}</td>
                      <td className="border border-1 text-right px-2">{data.OrderDetails ? getNgsCount(21) : 0}</td>
                      <td id="subTotal5" className="border border-1 text-right px-2">${(pr21 * getNgsCount(21)).toFixed(2)} </td>
                    </tr>
                    }
                    {getNgsCount(22) > 0 && 
                    <tr>
                      <td className="border border-1 px-2">Purified DNA {'>'} 550bp -- PCR Product -- de novo</td>
                      <td className="border border-1 text-right px-2">${pr22}</td>
                      <td className="border border-1 text-right px-2">{data.OrderDetails ? getNgsCount(22) : 0}</td>
                      <td id="subTotal6" className="border border-1 text-right px-2">${(pr22 * getNgsCount(22)).toFixed(2)} </td>
                    </tr>
                    }
                    {getNgsCount(23) > 0 && 
                    <tr>
                      <td className="border border-1 px-2">Purified DNA {'>'} 550bp -- Episome -- Map to Reference</td>
                      <td className="border border-1 text-right px-2">${pr23}</td>
                      <td className="border border-1 text-right px-2">{data.OrderDetails ? getNgsCount(23) : 0}</td>
                      <td id="subTotal7" className="border border-1 text-right px-2">${(pr23 * getNgsCount(23)).toFixed(2)} </td>
                    </tr>
                    }
                    {getNgsCount(24) > 0 && 
                    <tr>
                      <td className="border border-1 px-2">Purified DNA {'>'} 550bp -- Episome -- de novo</td>
                      <td className="border border-1 text-right px-2">${pr24}</td>
                      <td className="border border-1 text-right px-2">{data.OrderDetails ? getNgsCount(24) : 0}</td>
                      <td id="subTotal8" className="border border-1 text-right px-2">${(pr24 * getNgsCount(24)).toFixed(2)} </td>
                    </tr>
                    }
                    {getNgsCount(25) > 0 && 
                    <tr>
                      <td className="border border-1 px-2">Purified DNA {'>'} 550bp -- Bacterial gDNA -- Map to Reference</td>
                      <td className="border border-1 text-right px-2">${pr25}</td>
                      <td className="border border-1 text-right px-2">{data.OrderDetails ? getNgsCount(25) : 0}</td>
                      <td id="subTotal9" className="border border-1 text-right px-2">${(pr25 * getNgsCount(25)).toFixed(2)} </td>
                    </tr>
                    }
                    {getNgsCount(25_2) > 0 && 
                    <tr>
                      <td className="border border-1 px-2">Purified DNA {'>'} 550bp -- Bacterial gDNA -- 16S rRNA Metagenomics</td>
                      <td className="border border-1 text-right px-2">${pr25_2}</td>
                      <td className="border border-1 text-right px-2">{data.OrderDetails ? getNgsCount(25_2) : 0}</td>
                      <td id="subTotal10" className="border border-1 text-right px-2">${(pr25_2 * getNgsCount(25_2)).toFixed(2)} </td>
                    </tr>
                    }
                    {getNgsCount(26) > 0 && 
                    <tr>
                      <td className="border border-1 px-2">Purified DNA {'>'} 550bp -- Yeast gDNA -- Map to Reference</td>
                      <td className="border border-1 text-right px-2">${pr26}</td>
                      <td className="border border-1 text-right px-2">{data.OrderDetails ? getNgsCount(26) : 0}</td>
                      <td id="subTotal11" className="border border-1 text-right px-2">${(pr26 * getNgsCount(26)).toFixed(2)} </td>
                    </tr>
                    }
                    {getNgsCount(26_2) > 0 && 
                    <tr>
                      <td className="border border-1 px-2">Purified DNA {'>'} 550bp -- Yeast gDNA -- ITS Metagenomic</td>
                      <td className="border border-1 text-right px-2">${pr26_2}</td>
                      <td className="border border-1 text-right px-2">{data.OrderDetails ? getNgsCount(26_2) : 0}</td>
                      <td id="subTotal12" className="border border-1 text-right px-2">${(pr26_2 * getNgsCount(26_2)).toFixed(2)} </td>
                    </tr>
                    }
                    {getNgsCount(31) > 0 && 
                    <tr>
                      <td className="border border-1 px-2">Microbial colony/culture -- Episome -- Map to Reference</td>
                      <td className="border border-1 text-right px-2">${pr31}</td>
                      <td className="border border-1 text-right px-2">{data.OrderDetails ? getNgsCount(31) : 0}</td>
                      <td id="subTotal13" className="border border-1 text-right px-2">${(pr31 * getNgsCount(31)).toFixed(2)} </td>
                    </tr>
                    }
                    {getNgsCount(32) > 0 && 
                    <tr>
                      <td className="border border-1 px-2">Microbial colony/culture -- Episome -- de novo</td>
                      <td className="border border-1 text-right px-2">${pr32}</td>
                      <td className="border border-1 text-right px-2">{data.OrderDetails ? getNgsCount(32) : 0}</td>
                      <td id="subTotal14" className="border border-1 text-right px-2">${(pr32 * getNgsCount(32)).toFixed(2)} </td>
                    </tr>
                    }
                    {getNgsCount(33) > 0 && 
                    <tr>
                      <td className="border border-1 px-2">Microbial colony/culture -- Bacterial gDNA -- Map to Reference</td>
                      <td className="border border-1 text-right px-2">${pr33}</td>
                      <td className="border border-1 text-right px-2">{data.OrderDetails ? getNgsCount(33) : 0}</td>
                      <td id="subTotal15" className="border border-1 text-right px-2">${(pr33 * getNgsCount(33)).toFixed(2)} </td>
                    </tr>
                    }
                    {getNgsCount(34) > 0 && 
                    <tr>
                      <td className="border border-1 px-2">Microbial colony/culture -- Bacterial gDNA -- 16S rRNA Metagenomics</td>
                      <td className="border border-1 text-right px-2">${pr34}</td>
                      <td className="border border-1 text-right px-2">{data.OrderDetails ? getNgsCount(34) : 0}</td>
                      <td id="subTotal16" className="border border-1 text-right px-2">${(pr34 * getNgsCount(34)).toFixed(2)} </td>
                    </tr>
                    }
                    {getNgsCount(35) > 0 && 
                    <tr>
                      <td className="border border-1 px-2">Microbial colony/culture -- Yeast gDNA -- Map to Reference</td>
                      <td className="border border-1 text-right px-2">${pr35}</td>
                      <td className="border border-1 text-right px-2">{data.OrderDetails ? getNgsCount(35) : 0}</td>
                      <td id="subTotal17" className="border border-1 text-right px-2">${(pr35 * getNgsCount(35)).toFixed(2)} </td>
                    </tr>
                    }
                    {getNgsCount(36) > 0 && 
                    <tr>
                      <td className="border border-1 px-2">Microbial colony/culture -- Yeast gDNA -- ITS metagenomics</td>
                      <td className="border border-1 text-right px-2">${pr36}</td>
                      <td className="border border-1 text-right px-2">{data.OrderDetails ? getNgsCount(36) : 0}</td>
                      <td id="subTotal18" className="border border-1 text-right px-2">${(pr36 * getNgsCount(36)).toFixed(2)} </td>
                    </tr>
                    }
      
                    <tr>
                      <td className="border border-1 px-2 font-semibold">Total</td>
                      <td colSpan={3} className="border border-1 text-right px-2 font-semibold">{getTotalPrice()}</td>
                    </tr>
                  </tbody>
                  
                </table>
            </div>
			:
			data.OrderTypeId === 35 ? 
			<div className="w-full">
				<table className='w-full mt-2 text-[12px]'>
				<tbody>
					<tr>
						<th className='w-[34%] font-normal border border-1 px-2 text-center'>Item</th>
						<th className='w-[22%] font-normal border border-1 px-2 text-center'>Unit</th>
						<th className='w-[22%] font-normal border border-1 px-2 text-center'>Qty</th>
						<th className='w-[22%] font-normal border border-1 px-2 text-center'>SubTotal</th>                
					</tr> 
					{getWpsCount(11) > 0 && 
					<tr>
						<td className="border border-1 px-2">Plasmid -- Standard</td>
						<td className="border border-1 text-right px-2">${wps_standard}</td>
						<td className="border border-1 text-right px-2">{data.TableData ? getWpsCount(11) : 0}</td>
						<td id="subTotal1" className="border border-1 text-right px-2">${(wps_standard * getWpsCount(11)).toFixed(2)} </td>
					</tr>
					}
					{getWpsCount(12) > 0 && 
					<tr>
						<td className="border border-1 px-2">DNA fragment {'>'} 1Kb -- Standard</td>
						<td className="border border-1 text-right px-2">${wps_standard}</td>
						<td className="border border-1 text-right px-2">{data.TableData ? getWpsCount(12) : 0}</td>
						<td id="subTotal2" className="border border-1 text-right px-2">${(wps_standard * getWpsCount(12)).toFixed(2)} </td>
					</tr>
					}
					{getWpsCount(13) > 0 && 
						<tr>
							<td className="border border-1 px-2">Culture -- Standard</td>
							<td className="border border-1 text-right px-2">${Number(wps_standard)+Number(wps_culture)}</td>
							<td className="border border-1 text-right px-2">{data.TableData ? getWpsCount(13) : 0}</td>
							<td id="subTotal7" className="border border-1 text-right px-2">${((Number(wps_standard)+Number(wps_culture)) * getWpsCount(13)).toFixed(2)} </td>
						</tr>
					}
					{getWpsCount(21) > 0 && 
					<tr>
						<td className="border border-1 px-2">Plasmid -- Large</td>
						<td className="border border-1 text-right px-2">${wps_large}</td>
						<td className="border border-1 text-right px-2">{data.TableData ? getWpsCount(21) : 0}</td>
						<td id="subTotal3" className="border border-1 text-right px-2">${(wps_large * getWpsCount(21)).toFixed(2)} </td>
					</tr>
					}
					{getWpsCount(22) > 0 && 
					<tr>
						<td className="border border-1 px-2">DNA fragment {'>'} 1Kb -- Large</td>
						<td className="border border-1 text-right px-2">${wps_large}</td>
						<td className="border border-1 text-right px-2">{data.TableData ? getWpsCount(22) : 0}</td>
						<td id="subTotal4" className="border border-1 text-right px-2">${(wps_large * getWpsCount(22)).toFixed(2)} </td>
					</tr>
					}
					{getWpsCount(23) > 0 && 
						<tr>
							<td className="border border-1 px-2">Culture -- Large</td>
							<td className="border border-1 text-right px-2">${Number(wps_large)+Number(wps_culture)}</td>
							<td className="border border-1 text-right px-2">{data.TableData ? getWpsCount(23) : 0}</td>
							<td id="subTotal8" className="border border-1 text-right px-2">${((Number(wps_large)+Number(wps_culture)) * getWpsCount(23)).toFixed(2)} </td>
						</tr>
					}
					{getWpsCount(31) > 0 && 
					<tr>
						<td className="border border-1 px-2">Plasmid -- Very Large</td>
						<td className="border border-1 text-right px-2">${wps_veryLarge}</td>
						<td className="border border-1 text-right px-2">{data.TableData ? getWpsCount(31) : 0}</td>
						<td id="subTotal5" className="border border-1 text-right px-2">${(wps_veryLarge * getWpsCount(31)).toFixed(2)} </td>
					</tr>
					}
					{getWpsCount(32) > 0 && 
					<tr>
						<td className="border border-1 px-2">DNA fragment {'>'} 1Kb -- Very Large</td>
						<td className="border border-1 text-right px-2">${wps_veryLarge}</td>
						<td className="border border-1 text-right px-2">{data.TableData ? getWpsCount(32) : 0}</td>
						<td id="subTotal6" className="border border-1 text-right px-2">${(wps_veryLarge * getWpsCount(32)).toFixed(2)} </td>
					</tr>
					}
					{getWpsCount(33) > 0 && 
						<tr>
							<td className="border border-1 px-2">Culture -- Very Large</td>
							<td className="border border-1 text-right px-2">${Number(wps_veryLarge)+Number(wps_culture)}</td>
							<td className="border border-1 text-right px-2">{data.TableData ? getWpsCount(33) : 0}</td>
							<td id="subTotal9" className="border border-1 text-right px-2">${((Number(wps_veryLarge)+Number(wps_culture)) * getWpsCount(33)).toFixed(2)} </td>
						</tr>
					}
					
					<tr>
						<td className="border border-1 px-2 font-semibold">Total</td>
						<td id="subTotal101" colSpan={3} className="border border-1 text-right px-2 font-semibold">{getTotalPrice()}</td>
					</tr>

					{discountTemplate()}

					</tbody>
				
				</table>
			</div>
			:
          data.OrderTypeId === 50 ? 
            <div className="w-full">
                <table className='w-full mt-2 text-[12px]'>
                  <tbody>
                  <tr>
                        <th className='w-[34%] font-normal border border-1 px-2 text-center'>Item</th>
                        <th className='w-[22%] font-normal border border-1 px-2 text-center'>Unit</th>
                        <th className='w-[22%] font-normal border border-1 px-2 text-center'>Qty</th>
                        <th className='w-[22%] font-normal border border-1 px-2 text-center'>SubTotal</th>                
                    </tr> 
                    {
                      primerRow.bool === true && 
                      <tr>
                        <td className="border border-1 px-2">{primerRow.label==="PSPD"? `Primer Design and Synthesis`:`Primer Synthesis`}</td>
                        <td className="border border-1 text-right px-2">${getPrice('General', primerRow.label)}</td>
                        <td className="border border-1 text-right px-2">{primerRow.count}</td>
                        <td id="subTotal1" className="border border-1 text-right px-2">${getPrice('General', primerRow.label) * primerRow.count} </td>
                    </tr>
                    }
      
                    <tr>
                      <td className="border border-1 px-2 font-semibold">Total</td>
                      <td colSpan={3} className="border border-1 text-right px-2 font-semibold">{getTotalPrice()}</td>
                    </tr>
                  </tbody>
                  
                </table>
            </div>
          :
          data.OrderTypeId === 20 ?
          <div className="w-full">
          <table className='w-full mt-2 text-[12px]'>
            <tbody>
            <tr>
                  <th className='w-[34%] font-normal border border-1 px-2 text-center'>Item</th>
                  <th className='w-[22%] font-normal border border-1 px-2 text-center'>Unit</th>
                  <th className='w-[22%] font-normal border border-1 px-2 text-center'>Qty</th>
                  <th className='w-[22%] font-normal border border-1 px-2 text-center'>SubTotal</th>               
              </tr> 
              <tr>
                <td className="border border-1 px-2">{`gDNA QC (at least 1 ug each with A260/280 between 1.7 and 2.0, and A260/280 > 1.9)`}</td>
                <td className="border border-1 text-right px-2">${genomic_amt1}</td>
                <td className="border border-1 text-right px-2">{data.OrderDetails ? getGenomicCount(1) : 0}</td>
                <td id="subTotal1" className="border border-1 text-right px-2">${(genomic_amt1 * getGenomicCount(1)).toFixed(2)} </td>
              </tr>
              <tr>
                <td className="border border-1 px-2">{`PCR Product Generation (between 300-2kb)`}</td>
                <td className="border border-1 text-right px-2">${genomic_amt2}</td>
                <td className="border border-1 text-right px-2">{data.OrderDetails ? getGenomicCount(2) : 0}</td>
                <td id="subTotal2" className="border border-1 text-right px-2">${(genomic_amt2 * getGenomicCount(2)).toFixed(2)} </td>
              </tr>
              <tr>
                <td className="border border-1 px-2">{`Sequencing Phred 20 1X Overall`}</td>
                <td className="border border-1 text-right px-2">${genomic_amt3}</td>
                <td className="border border-1 text-right px-2">{data.OrderDetails ? getGenomicCount(3) : 0}</td>
                <td id="subTotal3" className="border border-1 text-right px-2">${(genomic_amt3 * getGenomicCount(3)).toFixed(2)} </td>
              </tr>
              <tr>
                <td className="border border-1 px-2">{`Primer Synthesis Without Design`}</td>
                <td className="border border-1 text-right px-2">${genomic_amt4}</td>
                <td className="border border-1 text-right px-2">{data.OrderDetails ? getGenomicCount(4) : 0}</td>
                <td id="subTotal4" className="border border-1 text-right px-2">${(genomic_amt4 * getGenomicCount(4)).toFixed(2)} </td>
              </tr>
              <tr>
                <td className="border border-1 px-2">{`Primer Synthesis Plus Design`}</td>
                <td className="border border-1 text-right px-2">${genomic_amt5}</td>
                <td className="border border-1 text-right px-2">{data.OrderDetails ? getGenomicCount(5) : 0}</td>
                <td id="subTotal5" className="border border-1 text-right px-2">${(genomic_amt5 * getGenomicCount(5)).toFixed(2)} </td>
              </tr>
              <tr>
                <td className="border border-1 px-2">{`PCR Gel Purification`}</td>
                <td className="border border-1 text-right px-2">${genomic_amt6}</td>
                <td className="border border-1 text-right px-2">{data.OrderDetails ? getGenomicCount(6) : 0}</td>
                <td id="subTotal6" className="border border-1 text-right px-2">${(genomic_amt6 * getGenomicCount(6)).toFixed(2)} </td>
              </tr>
              <tr>
                <td className="border border-1 px-2">{`Consensus seq, alignment and variant report per target`}</td>
                <td className="border border-1 text-right px-2">${genomic_amt7}</td>
                <td className="border border-1 text-right px-2">{data.OrderDetails ? getGenomicCount(7) : 0}</td>
                <td id="subTotal7" className="border border-1 text-right px-2">${(genomic_amt7 * getGenomicCount(7)).toFixed(2)} </td>
              </tr>
             
              <tr>
                <td className="border border-1 px-2 font-semibold">Total</td>
                <td colSpan={3} className="border border-1 text-right px-2 font-semibold">{getTotalPrice()}</td>
              </tr>
            </tbody>
            
          </table>
          </div>
          :
          null
        }
            <table className='w-full mt-6 text-[12px]'>
                <tbody>
                  <tr>
                        <td className='w-[22%] font-normal border border-1 px-2 text-left'>FullName</td>
                        <td className='w-[28%] font-normal border border-1 px-2 text-left'>{billingInfo ? `${billingInfo.FirstName} ${billingInfo.LastName}`:"N/A"}</td>
                        <td className='w-[22%] font-normal border border-1 px-2 text-left'>Email</td>
                        <td className='w-[28%] font-normal border border-1 px-2 text-left'>{billingInfo ? `${billingInfo.EmailAddress}`:"N/A"}</td>                
                    </tr> 
                    <tr>
                        <th className='w-[22%] font-normal border border-1 px-2 text-left'>Company</th>
                        <th className='w-[28%] font-normal border border-1 px-2 text-left'>{billingInfo ? `${billingInfo.CorporateName}`:"N/A"}</th>
                        <th className='w-[22%] font-normal border border-1 px-2 text-left'>Phone</th>
                        <th className='w-[28%] font-normal border border-1 px-2 text-left'>{billingInfo ? `${billingInfo.PhoneNumber}`:"N/A"}</th>                
                    </tr> 
                    <tr>
                      <td className="border border-1 px-2">PI</td>
                      <td colSpan={3} className="border border-1 px-2">{billingInfo ? `${billingInfo.pinvestigator}`:""}</td>
                    </tr>
                </tbody>
              </table>
        </div>

        <div className="mt-5">
          <p className="text-[12px]">Order Detail Information</p>
          <table className='w-full mt-2'>
            <tbody>
              {orderDetailData.map((item,key) => (
                item.header === 'empty' ?
                <tr key={key}>
                  <th className="hidden"></th>
                  <td className="hidden"></td>
                </tr>
                :
                <tr key={key}>
                    <th className={`w-[30%] border border-1 text-left text-[12px] px-2 font-normal`}>{item.header}</th>
                    <td className={`w-[70%] border border-1 text-left text-[12px] px-2 font-semibold`}>{item.value}</td>         
                </tr>  
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-5 mb-40">
          {data.OrderTypeId === 25 && <>
          <p className="text-[12px]">DNA Sample Information</p>
            <div className='w-full overflow-x-auto'>
              <SppeTemplate/>
            </div> 
          </> 
          }

          {data.OrderTypeId === 34 && <>
          <p className="text-[12px]">DNA Sample Information</p>
            <div className='w-full overflow-x-auto'>
              <DcssTemplate/>
            </div> 
          </>
          }

          {data.OrderTypeId === 28 && <>
          <p className="text-[12px]">DNA Sample Information</p>
            <div className='w-full overflow-x-auto'>
              <HtpTemplate/>
            </div> 
          </>
          }
		
			{data.OrderTypeId === 38 && <>
			<p className="text-[12px]">DNA Sample Information</p>
			<div className='w-full overflow-x-auto'>
				<FlaTemplate/>
			</div> 
			</>
			}
			
          {data.OrderTypeId === 29 && <>
          <p className="text-[12px]">DNA Sample Information</p>
            <div className='w-full overflow-x-auto'>
              <FsaTemplate/>
            </div> 
          </>
          }

          {data.OrderTypeId === 37 && <>
          <p className="text-[12px]">DNA Sample Information</p>
            <div className='w-full overflow-x-auto'>
              <NgsTemplate/>
            </div> 
          </>
          }

		{data.OrderTypeId === 35 && <>
			<p className="text-[12px]">DNA Sample Information</p>
			<div className='w-full overflow-x-auto'>
				<WpsaTemplate/>
			</div> 
		</>
		}

          {data.OrderTypeId === 20 && <>
          <p className="text-[12px]">DNA Sample Information</p>
            <div className='w-full overflow-x-auto'>
              <GenomicTemplate/>
            </div> 
          </>
          }


          {data.PrimerSynthesis !== 0 && data.PrimerSynthesis !== null && 
          <>
            <p className=" mt-6 text-[12px]">Primer Synthesis Information</p>
            <div>
              <PrimerDataTemplate/>
            </div>
          </>
          }
        </div>
      </div>
    </>
      :
      linkExpiredMessage === true ? 
      <p className="text-3xl text-red-500 p-2 text-center mt-10">LINK IS EXPIRED !!</p>
      :
      showCompletion === true ? 
      <p className="text-3xl text-blue-500 p-2 text-center mt-10">PAYMENT DONE SUCCESSFULLY. PLEASE CLOSE THE WINDOW.</p>
      :
      alreadyPaid === true ?
      <p className="text-3xl text-blue-500 p-2 text-center mt-10">YOUR PA HAS APPROVED THE ORDER. PLEASE CLOSE THE WINDOW.</p>
      :
      <p className="p-2">Loading..</p>
    }     
    </>
  );
}

export default ViewPaLink;